const en = {
  en: 'English',
  header: {
    menu: 'menu',
    search: 'search',
    searchPlaceholder: 'type an API or well name and select a result',
    clear: 'clear',
    user: 'Current User',
  },
  topNav: {
    searchPlaceholder: 'Type an API or Well Name',
    openWells: 'Open Wells',
  },
  nav: {
    profile: 'Profile',
    jobManagement: 'Job Management',
    allOpenCases: 'All Open Cases',
    menu: 'Menu',
    reports: 'Reports',
    options: 'Options',
    delegatedRules: 'Delegated Rules',
    majorJobs: 'Major Jobs',
    minorJobs: 'Minor Jobs',
    submissions: 'Submissions',
    land: 'Land',
    engineering: 'Engineering',
    planning: 'Planning',
    scheduling: 'Scheduling',
    execution: 'Execution',
    closeOut: 'Close Out',
    nonRig: 'Non-Rig',
    casingPressure: 'Casing Pressure',
    reclamation: 'Reclamation',
    facilityDecommission: 'Facility Decommission',
    plugAbandonment: 'Plug & Abandonment',
    helpDashboard: 'Help Dashboard',
    userManagement: 'User Management',
    profileConfiguration: 'Profile Configuration',
  },
  app: {
    title: 'Centaur - Workflow Management',
    homeTitle: 'Workflow Management',
    welcomeMessage: 'Welcome to Centaur Web Application',
    forms: {
      add: 'Add',
      save: 'Save',
      cancel: 'Cancel',
      create: 'Create',
      edit: 'Edit',
      delete: 'Delete',
      continue: 'Continue',
      close: 'Close',
      labels: {
        businessUnit: 'Business Unit',
        placeholderBusinessUnit: 'Select Business Unit',
        language: 'Language',
      },
    },
  },
  navigation: {
    jobManagement: 'Job Management',
    allOpenCases: 'All Open Cases',
    userManagement: 'User Management',
    admin: 'Admin',
    adminUsers: 'User Management',
    adminNotificationPreferences: 'Email Preference Catalog',
    adminCaseTypePermissions: 'Case Type Permissions',
  },
  sidebar: {
    navigation: 'navigation',
    menu: 'menu',
    majorJobs: 'major jobs',
    minorJobs: 'minor jobs',
    reports: 'reports',
    options: 'options',
    delegatedRules: 'delegated rules',
    submissions: 'submissions',
    land: 'land',
    engineering: 'engineering',
    planning: 'planning',
    execution: 'execution',
    scheduling: 'scheduling',
    closeOut: 'close out',
    nonRig: 'non-rig',
    casingPressure: 'casing pressure',
    reclamation: 'reclamation',
    facilityDecommission: 'facility decommission',
  },
  actionBar: {
    metrics: 'Metrics',
    communications: 'Communications',
    information: 'Information',
  },
  burgerMenu: {
    reports: 'Reports',
    options: 'Options',
    delegatedRules: 'Delegated Rules',
    wellManager: 'Well Manager',
    submissions: 'Submissions',
    land: 'Land',
    engineering: 'Engineering',
    nonRig: 'Non-Rig',
    casingPressure: 'Casing Pressure',
  },
  common: {
    language: 'Language',
    back: 'Back',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    noData: 'No data available',
    notAvailable: 'N/A',
    genericErrorMessage: 'An unexpected error occurred. Please try again.',
    forbidActionErrorMessage:
      'You do not have permission to perform this action.',
    search: 'Search',
    clear: 'Clear',
    expand: 'Expand',
    collapse: 'Collapse',
    refresh: 'Refresh',
    create: 'Create',
    download: 'Download',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    date: 'Date',
    actions: 'Actions',
    open: 'Open',
    close: 'Close',
    selectDate: 'Select a date',
    notSet: '—',
  },
  planning: {
    title: 'Planning',
    placeholder: 'Content will be added in a future update.',
    tabs: {
      wlmReview: 'WLM Review',
      rigless: 'Rigless',
      paSsProcedure: 'P&A SS Procedure',
      paSiteReview: 'P&A Site Review',
    },
    rigless: {
      searchPlaceholder: 'Enter search keyword',
      empty: 'No rigless planning rows match the current search.',
      table: {
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        daysInCurrentStep: 'Days in Current Step',
        companyCode: 'Company Code',
        costCenter: 'Cost Center',
        plantCode: 'Plant Code',
        failureDate: 'Failure Date',
        daysDown: 'Days Down',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        avgTotalProductionBoed: 'Avg Total Production (BOED)',
        proactiveReactive: 'Proactive / Reactive',
        reasonForPull: 'Reason For Pull',
        faaNotification: 'FAA Notification',
      },
    },
  },
  scheduling: {
    title: 'Scheduling',
    placeholder: 'Content will be added in a future update.',
    tabs: {
      pullRequests: 'Pull Requests',
      pa: 'P&A',
      rigless: 'Rigless',
      workOrderSubmissions: 'Work Order Submissions',
      activeSchedule: 'Active Schedule',
      stalePullRequests: 'Stale Pull Requests',
    },
    rigless: {
      searchPlaceholder: 'Enter search keyword',
      empty: 'No rigless scheduling rows match the current search.',
      actions: {
        openSchedulingDetail: 'Open scheduling detail',
      },
      tooltips: {
        disabledUntilWellview:
          'Scheduling disabled until a TA confirms the job has been entered into Wellview.',
      },
      table: {
        moveToActive: 'Move to Active',
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        padPackage: 'Pad/Package',
        wellviewJob: 'Wellview Job',
        preScheduleStatus: 'Pre-Schedule Status',
        estimatedDays: 'Est Days',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        hasProtectedSpecies: 'Has Protected Species?',
      },
    },
    common: {
      sections: {
        caseOverview: 'Case Overview',
      },
      fields: {
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        lastUpdatedBy: 'Last updated by',
        lastUpdatedDate: 'Last Updated Date',
      },
    },
    wellviewDialog: {
      title: 'Edit Wellview Job Flags',
      sections: {
        caseOverview: 'Case Overview',
        wellviewJob: 'Wellview Job',
      },
      fields: {
        enteredIntoWellview: 'Has this job been entered into Wellview?',
      },
      messages: {
        updated: 'Wellview job selected successfully.',
      },
    },
    paWellviewDialog: {
      title: 'Edit Well View Job Flags',
    },
    statusDialog: {
      title: 'Change Pre-Schedule Status',
      sections: {
        caseOverview: 'Case Overview',
        preSchedule: 'Pre-Schedule',
      },
      fields: {
        status: 'Status',
        comments: 'Comments',
      },
      placeholders: {
        status: '-select-',
        comments: 'Enter comments',
      },
      messages: {
        updated: 'Pre-Schedule status changed successfully.',
      },
    },
    detail: {
      title: 'Scheduling Details',
      header: {
        titleSuffix: 'Scheduling Details',
        badge: 'PRE SCHEDULE',
      },
      stages: {
        planning: 'PLANNING',
        scheduling: 'SCHEDULING',
        execution: 'EXECUTION',
        closeOut: 'CLOSE OUT',
      },
      sections: {
        schedulerValues: 'Scheduler Values',
        selectRig: 'Select Rig',
        selectQueueOrder: 'Select Queue Order',
      },
      fields: {
        prairieChickenPolygon:
          'Is Well On Prairie Chicken/ Dune Lizard Polygon?',
        electricalVariance: 'Electrical Variance',
        simops: 'SIMOPS',
        airportPolygon: 'Is Well On Airport Polygon?',
        api12: 'API 12',
        wellheadHeight: 'Wellhead Height (inches)',
        notificationForm: 'What Form Of Notification?',
        aeronauticalStudyNumber: 'Aeronautical Study Number',
        priorityIssue: 'Priority Issue',
        priorityDate: 'Priority Date',
        priorityWellComments: 'Priority Well Comments',
        rigId: 'Rig ID',
        queueOrder: 'Queue Order',
        workflowDetermination: 'Workflow Determination',
        dpiRatio: 'DPI-Ratio',
        bblsPerMonth: 'BBLS/M',
        production: 'Production',
        gkScore: 'GK Score',
        rigUp: 'Rig Up',
        projectedRigDown: 'Proj. Rig Down',
        projectedJobDays: 'Projected Job Days',
      },
      placeholders: {
        select: '-select-',
        priorityComments: 'Enter priority comments',
      },
      actions: {
        dragQueueRow: 'Drag to reorder queue row',
      },
      values: {
        yes: 'Yes',
        no: 'No',
        rigless: 'Rigless',
        pullRequest: 'Pull Request',
      },
      messages: {
        saved: 'Scheduling details saved successfully.',
        submitted: 'Rig selection and scheduling submitted successfully.',
        noRigsAvailable: 'No rigs are available. Contact an administrator to add rigs before scheduling.',
      },
      validation: {
        title: 'Complete Required Fields',
        description:
          'Complete the required scheduling fields before submitting this case.',
      },
    },
  },
  execution: {
    title: 'Execution',
    detailPlaceholder:
      'Execution detail form content will be added in a future update.',
    tabs: {
      activeSchedule: 'Active Schedule',
      submittedFinals: 'Submitted Finals',
      paActiveSchedule: 'P&A Active Schedule',
      centralMaintenance: 'Central Maintenance',
      digPlan: 'Dig Plan',
      wellheadRemoval: 'Wellhead Removal',
      stalePullRequests: 'Stale Pull Requests',
    },
    activeSchedule: {
      searchPlaceholder: 'Enter search keyword',
      empty: 'No active schedule rows match the current search.',
      actions: {
        openAttachments: 'Open available attachments',
      },
      table: {
        actions: 'Actions',
        status: 'Status',
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        conservationRequired: 'Conservation Required',
        priorityDate: 'Priority Date',
        activeScheduleComment: 'Active Schedule Comment',
        rigNumber: 'Rig #',
        ruDate: 'RU Date',
        rdDate: 'RD Date',
        avgTotalProductionBoed: 'Avg Total Prod. (BOED)',
        wellviewJobId: 'Wellview Job ID',
        autoProgressionDisabled: 'Auto Progression Disabled?',
        dpi: 'DPI',
      },
    },
    attachmentsDialog: {
      title: '{{caseId}} Available Attachments',
      empty: 'No downloads are currently available for this case.',
    },
    detail: {
      screenTitle: 'Execution Detail',
      tabs: {
        jobPlanReview: 'Planning Review',
        execution: 'Execution',
      },
      executionSubTabs: {
        details: 'Details',
        rigReport: 'Rig Report',
      },
      detailsTabs: {
        wellInformation: 'Well Information',
        jobCostAttributes: 'Job Cost Attributes',
        compliance: 'Compliance',
        failureInformation: 'Failure Information',
        adminWsmUserIdOverride: 'Admin WSM UserID Override',
      },
      labels: {
        confirmCompliance: 'Confirm Compliance',
        userIdForOverride: 'UserID for Override',
        userIdForOverridePlaceholder: 'Search by name or email',
      },
      messages: {
        noDirections: 'No directions available on this well',
        sentBackToScheduling: 'Case sent back to scheduling.',
        rigReportLastPulled: 'Data Last Pulled:',
        saved: 'Execution details saved successfully.',
        submitted: 'Execution submitted successfully.',
      },
      validation: {
        title: 'Complete Required Fields',
        description:
          'Enter the required fields below before submitting this case for review.',
      },
      preSchedulingDialog: {
        title: 'Pre-Scheduling Details',
        placeholders: {
          status: 'Select pre-schedule status',
          comments: 'Enter comment',
        },
      },
      actions: {
        downloadConservationAgreement: 'Download Conservation Agreement',
        supportingPicsReports: 'Supporting Pics/Reports  +  Attach new',
        refreshRigReport: 'Refresh Rig Report',
        sendBackToPreScheduling: 'send back to pre-scheduling',
        sendReports: 'Send Reports',
      },
      failureTable: {
        failure: 'Failure',
        reason: 'Reason',
        size: 'Size',
        depth: 'Depth',
        type: 'Type',
        cause: 'Cause',
        failureComment: 'Failure Comment',
      },
      rigReportTable: {
        date: 'Date',
        wsmName: 'WSM Name',
        totalHoursWorked: 'Total Hours Worked',
        dailyCost: 'Daily Cost',
        projectedOperations: 'Projected Operations',
      },
      hourlyRemarksTable: {
        activityStart: 'Activity Start',
        activityEnd: 'Activity End',
        comments: 'Comments',
        duration: 'Duration',
      },
      fields: {
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        status: 'Status',
        rigNumber: 'Rig #',
        avgTotalProductionBoed: 'Avg Total Production (BOED)',
        latitude: 'Latitude',
        longitude: 'Longitude',
        jobStart: 'Job Start',
        state: 'State',
        companyCode: 'Company Code',
        localReferenceNumber: 'Local Reference Number',
        area: 'Area',
        costCenter: 'Cost Center',
        wellTest1Boed: 'Well Test 1 (BOED)',
        wellTest2Boed: 'Well Test 2 (BOED)',
        wellTest3Boed: 'Well Test 3 (BOED)',
        wbs: 'WBS?',
        wbsNumber: 'WBS Number',
        liftMethod: 'Lift Method',
        field: 'Field',
        plantCode: 'Plant Code',
        failureDate: 'Failure Date',
        jobType: 'Job Type',
        isWellRigReady: 'Is Well Rig Ready?',
        comments: 'Comments',
        jobReason: 'Job Reason',
        multiPadWell: 'Multi Pad Well (SIMOPS)',
        projectedJobDays: 'Projected Job (days)',
        plannedCost: 'Planned Cost',
        preScheduleStatus: 'Pre-Schedule Status',
        preScheduleComment: 'Pre-Schedule Comment',
        avgBoed: 'Avg BOED',
        enteredIntoWellview: 'Has this job been entered into Wellview?',
        wellviewJobList: 'Wellview Job List',
        wellviewJobType: 'Wellview Job Type',
        wellviewJobId: 'Wellview Job ID',
        wellviewJobCreationDate: 'Wellview Job Creation Date',
        jobClosed: 'Job Closed?',
        jobEnd: 'Job End',
        costToDate: 'Cost to Date',
        totalHours: 'Total Hours',
        differenceGross: 'Difference Gross',
        confirmElectricalVariance: 'Confirm Electrical Variance',
        confirmSimops: 'Confirm SIMOPS',
        wellviewWellboreUpdated: 'Wellview Wellbore is updated?',
        rigDownDateInWellview: 'Rig down date is in Wellview?',
        jobs: 'Jobs',
        disableAutomaticProgression: 'Disable Automatic Progression?',
        rigUpDate: 'Rig Up Date',
      },
    },
  },
  planningDetails: {
    header: {
      titleSuffix: 'Planning Details',
      badge: 'Planning',
      contacts: 'Contacts',
      auditLog: 'Audit Log',
      attachments: 'Attachments',
    },
    stages: {
      planning: 'Planning',
      scheduling: 'Scheduling',
      execution: 'Execution',
      closeOut: 'Close Out',
    },
    common: {
      selectPlaceholder: '-select-',
    },
    search: {
      plantCodePlaceholder: 'Search Plant Codes',
      plantCodeLabel: 'Plant Code',
      companyCodeLabel: 'Company Code',
    },
    sections: {
      wellInformation: 'Well Information',
      jobInformation: 'Job Information',
      jobPlanPacket: 'Job Plan Packet',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      liftMethod: 'Lift Method',
      field: 'Field',
      state: 'State',
      area: 'Area',
      fot: 'FOT',
      plantCode: 'Plant Code',
      companyCode: 'Company Code',
      costCenter: 'Cost Center',
      latitude: 'Latitude',
      longitude: 'Longitude',
      failureDate: 'Failure Date',
      localReferenceNumber: 'Local Reference Number',
      wellTest1Boed: 'Well Test 1 (BOED)',
      wellTest2Boed: 'Well Test 2 (BOED)',
      wellTest3Boed: 'Well Test 3 (BOED)',
      wbs: 'WBS?',
      wbsNumber: 'WBS Number',
      jobType: 'Job Type',
      jobReason: 'Job Reason',
      avgBoed: 'Avg BOED',
      multiPadWell: 'Multi Pad Well (SIMOPS)',
      comments: 'Comments',
    },
    packet: {
      attach: 'Attach Job Plan Packet',
      attached: 'Job Plan Packet is attached.',
      notAttached: 'Job Plan Packet is not attached.',
    },
    messages: {
      saved: 'Planning details saved successfully.',
      caseNotResolved: 'Case could not be resolved. Please try again.',
    },
    validation: {
      fotUnknown: 'FOT — value must not be UNKNOWN',
      failureDateFuture: 'Failure date must not be in the future.',
    },
    actions: {
      closeRiglessRequest: 'close rigless request',
      goBack: 'go back',
      cancel: 'cancel',
      save: 'save',
      sendToJobPlan: 'send to job plan',
    },
  },
  planningJobPlan: {
    sections: {
      wellviewJob: 'Wellview Job',
    },
    fields: {
      projectedJobDays: 'Projected Job (days)',
      isWellRigReady: 'Is Well Rig Ready?',
      preScheduleStatus: 'Pre-Schedule Status',
      preScheduleComment: 'Pre-Schedule Comment',
      plannedCost: 'Planned Cost',
      enteredIntoWellview: 'Has this job been entered into Wellview?',
      wellviewJobList: 'Wellview Job List',
      wellviewJobId: 'Wellview Job ID',
      wellviewJobType: 'Wellview Job Type',
      wellviewJobCreationDate: 'Wellview Job Creation Date',
    },
    wellview: {
      intro:
        'If the Wellview job has been entered, check the box and complete the required fields.',
      followUp:
        'If completed now, you do not need to repeat this step during Pre-Scheduling.',
      selectionHint:
        'Selecting a job from the list will automatically populate the Wellview Job ID field. If the job does not appear, please enter the Wellview Job ID directly.',
      jobIdHint: 'same as idcreparent in wellview?',
      listPlaceholder: 'search wellview jobs',
      loadingJobs: 'Fetching Wellview jobs...',
      noJobsFound: 'No Wellview jobs found for this well.',
      retryJobs: 'retry',
    },
    actions: {
      submit: 'submit',
    },
    validation: {
      title: 'Complete Required Fields',
      description:
        'Enter the required fields below before sending this case to Job Plan.',
      dismiss: 'ok',
    },
  },
  planningReview: {
    header: {
      titleSuffix: 'Case Review (Read-Only)',
      badges: {
        planning: 'PLANNING',
        scheduling: 'PRE SCHEDULE',
        execution: 'EXECUTION',
        closeOut: 'CLOSE OUT',
        resolvedCompleted: 'RESOLVED COMPLETED',
        resolvedPlanToPA: 'RESOLVED - PLAN TO PA',
        resolvedDivest: 'RESOLVED - DIVESTED',
        resolvedError: 'RESOLVED - DUPLICATE/HUMAN ERROR',
      },
    },
    stages: {
      planning: 'PLANNING',
      scheduling: 'SCHEDULING',
      execution: 'EXECUTION',
      closeOut: 'CLOSE OUT',
    },
    messages: {
      generated:
        'Thank you! The economics page has been generated and the next step in this case has been routed appropriately.',
      rlCaseComplete: 'Thank you. The RL case is complete.',
    },
    validation: {
      title: 'Complete Required Fields',
      description:
        'Enter the required fields below before submitting this case for review.',
    },
    tabs: {
      planningReview: 'Planning Review',
      execution: 'Execution',
      executionReview: 'Execution Review',
      closeOut: 'Close Out',
    },
    execution: {
      tabs: {
        details: 'Details',
        rigReport: 'Rig Report',
      },
    },
    executionTabs: {
      wellInformation: 'Well Information',
      rigReport: 'Rig Report',
      jobCostAttributes: 'Job Cost Attributes',
      compliance: 'Compliance',
      failureInformation: 'Failure Information',
    },
    values: {
      yes: 'Yes',
      no: 'No',
      true: 'True',
      false: 'False',
      notAvailable: '--',
      notEntered: '—',
      rigReady: 'Rig Ready',
    },
    actions: {
      editCloseOutDetails: 'Edit Close Out Details',
    },
  },
  planningCloseRequest: {
    header: {
      titleSuffix: 'Close {{caseType}} Request',
    },
    badges: {
      planning: 'PLANNING',
      scheduling: 'PRE SCHEDULE',
      execution: 'EXECUTION',
      closeOut: 'CLOSE OUT',
    },
    stages: {
      planning: 'PLANNING',
      scheduling: 'SCHEDULING',
      execution: 'EXECUTION',
      closeOut: 'CLOSE OUT',
    },
    sections: {
      closureDetails: 'Closure Details',
      closureDescription: 'Specify case closure details',
      submitHint: 'Click submit if you wish to close this case.',
    },
    fields: {
      reasonForCancellation: 'Reason for Cancellation',
      description: 'Description',
    },
    placeholders: {
      reasonForCancellation: '-select-',
      description: 'Enter a brief description of the closure request',
    },
    reasons: {
      duplicateHumanError: 'Duplicate/Human Error',
      planToPA: 'Plan to PA',
      wellDivested: 'Well Divested',
      wellRecovered: 'Well Recovered',
    },
    actions: {
      cancel: 'cancel',
      submit: 'submit',
    },
    messages: {
      closed: 'The rigless request has been closed successfully.',
    },
    validation: {
      title: 'Complete Required Fields',
      description:
        'Enter the required closure details below before submitting this request.',
    },
  },
  planningResolvedError: {
    title: 'Resolved Error Form',
    placeholder:
      'This placeholder route has been added so the close-request flow can continue until the resolved error form is defined.',
  },
  planningCloseOut: {
    header: {
      titleSuffix: 'Close Out Details',
    },
    sections: {
      wellInformation: 'Well Information',
      failureDescription: 'Failure Description',
      failureAnalysis: 'Failure Analysis',
    },
    fields: {
      oilBopd: 'Oil (BOPD)',
      waterBwpd: 'Water (BWPD)',
      gasMcfpd: 'Gas (MCFPD)',
      failedComponentGroup: 'Failed Component Group',
      failedComponentType: 'Failed Component Type',
      failureRemarks: 'Failure Remarks',
      failureLocation: 'Failure Location',
      failureDepth: 'Failure Depth',
      componentDisposition: 'Component Disposition',
      analysisCompletionDate: 'Failure Analysis Completion Date',
      primaryFailureClass: 'Primary Failure Class',
      remarks: 'Remarks',
      primaryFailureCause: 'Primary Failure Cause',
      rootFailureCause: 'Root Failure Cause',
      preventativeMaintenance: 'Preventative Maintenance',
      actualJobCost: 'Actual Job Cost',
      personPerformingTask: 'Person Performing Task',
      failureSolution: 'Failure Solution',
      failureObservations: 'Failure Observations',
      failure: 'Failure',
      reason: 'Reason',
      responsiblePerson: 'Responsible Person',
      wellviewWellboreValidated: 'Wellview Wellbore Validated?',
    },
    actions: {
      sendBackToExecution: 'send back to execution',
      sendToCloseOut: 'send to close out',
    },
    messages: {
      saved: 'Close out details saved successfully.',
      sentBackToExecution: 'Case sent back to execution.',
      submitted: 'Case closed out successfully.',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Enter the required fields below before closing out this case.',
    },
    sendBackDialog: {
      title: 'Close Out Details',
      placeholders: {
        reason: 'Enter reason',
      },
    },
    search: {
      responsiblePersonPlaceholder: 'Type a user name or email (min. 3 chars)...',
    },
    options: {
      failedComponentGroups: {
        tubing: 'Tubing',
        rod: 'Rod',
        surface: 'Surface',
        pump: 'Pump',
      },
      failedComponentTypes: {
        valve: 'Valve',
        pump: 'Pump',
        tubing: 'Tubing',
        rod: 'Rod',
      },
      failureLocations: {
        downhole: 'Downhole',
        surface: 'Surface',
        tubing: 'Tubing',
        casing: 'Casing',
      },
      componentDispositions: {
        repair: 'Repair',
        replace: 'Replace',
        monitor: 'Monitor',
        unknown: 'Unknown',
      },
    },
  },
  planningAttachments: {
    title: 'Attachments',
    tabs: {
      attachments: 'Attachments',
      correspondence: 'Correspondence',
    },
    upload: {
      dragDrop: 'Drag and drop files here',
      or: 'or',
      selectFiles: 'Select file(s)',
    },
    categories: {
      file: 'File',
      jobPlanPacket: 'Job Plan Packet',
      mitigationPlan: 'Mitigation Plan',
    },
    messages: {
      attachSuccessSingle: '{{count}} file attached successfully.',
      attachSuccessMultiple: '{{count}} files attached successfully.',
      attachFailure: '{{count}} file(s) failed to upload. Please try again.',
      deleteSuccess: 'Attachment deleted successfully.',
    },
    errors: {
      invalidExcelFileType: 'Invalid Excel file type. Please upload using the {{extensions}} file type(s).',
    },
    pending: {
      columns: {
        name: 'Name',
        file: 'File',
        category: 'Category',
        size: 'Size (KB)',
        remove: 'Remove',
      },
    },
    attachments: {
      columns: {
        type: 'Type',
        name: 'Name',
        category: 'Category',
        uploadedBy: 'Uploaded By',
        uploadedOn: 'Uploaded On',
        size: 'Size (KB)',
      },
      empty: 'No attachments are currently associated with this case.',
    },
    correspondence: {
      columns: {
        type: 'Type',
        name: 'Name',
        recipient: 'Recipient',
        sentOn: 'Sent On',
        status: 'Status',
        download: 'Download',
      },
      empty: 'No system correspondence has been sent for this case.',
    },
    actions: {
      attach: 'Attach',
    },
  },
  planningAuditLog: {
    title: 'Audit Log',
    noEntries: 'No audit entries found.',
    sections: {
      history: 'History',
    },
    columns: {
      time: 'Time',
      description: 'Description',
      performedBy: 'Performed by',
    },
    actions: {
      okay: 'okay',
    },
    actionLabels: {
      sentToJobPlan: 'Case Sent to Job Planning',
    },
  },
  planningContacts: {
    title: 'Contacts',
    actions: {
      okay: 'okay',
    },
  },
  planningProtectedSpecies: {
    badge: 'This well is on a protected species polygon',
    actions: {
      openDetails: 'Open protected species details',
    },
    types: {
      prairieChickenZone1: 'In Prairie Chicken Zone 1',
      prairieChickenZone2: 'In Prairie Chicken Zone 2',
      duneLizardNm: 'In Dune Lizard Area (NM)',
      duneLizardTx: 'In Dune Lizard Area (TX)',
      hornshellMussel: 'In Hornshell Mussel Area',
      blmLand: 'In BLM Land',
    },
    intro:
      'If the well work will result in any new surface disturbance, additional project stipulations may apply. Please contact MCBU\'s Environmental Process Advisor for further guidance.',
    stipulations: {
      prairieChickenNm: {
        bullet1:
          'Activities that produce noise or involve human activity, such as MMWW or RWW, will not be allowed between 3:00 am and 9:00 am. The 3:00 am to 9:00 am restriction will not apply to normal, around-the-clock operations, such as venting, flaring, or pumping, which do not require a human presence during this period. Normal vehicle use on existing roads will not be restricted. Exceptions to these requirements would be considered in emergency situations, such as mechanical failures, but would not be considered for routine planned events.',
        bullet2: 'Minimize Off-Highway Vehicle (OHV) activity.',
      },
      duneLizardTx: {
        bullet1:
          'Minimize Off-Highway Vehicle (OHV) activity by using existing roads, pads, and utility easements for OHVs where feasible',
        bullet2: 'Minimize spills through inspection, monitoring, maintenance, and training',
        bullet3: 'Avoid introduction of invasive vegetation',
        bullet4: 'Control dust, including restricting unnecessary OHV access',
      },
      hornshellMussel: {
        bullet1:
          'Do not release, plant or otherwise establish or introduce exotic or invasive species, including but not limited to saltcedar, giant cane, cheatgrass, Lehmann\'s lovegrass, Zebra Mussels, Sheepshead minnow, feral pigs, or other species that may degrade habitat.',
        bullet2: 'Comply with SPCC requirements',
      },
    },
  },
  optionsPage: {
    title: 'Options',
    subtitle:
      'Manage personal preferences, administrative configuration, and operational reference settings from one place.',
    comingSoon: 'Coming Soon',
    sections: {
      admin: {
        title: 'Administration',
        description:
          'User, notification, and platform configuration for administrators.',
      },
      distributions: {
        title: 'Distributions',
        description: 'Manage report and schedule distribution lists.',
      },
      historicalJobs: {
        title: 'Historical Jobs',
        description: 'Reference and analyze previous job categories and archives.',
      },
      templates: {
        title: 'Templates',
        description: 'Find reusable forms, scopes, and procedural templates.',
      },
      miscellaneous: {
        title: 'Miscellaneous',
        description: 'Other operational configuration items.',
      },
    },
    items: {
      userManagement: {
        label: 'User Management',
        description: 'Provision users and manage their roles, FOTs, and access.',
      },
      delegatedRules: {
        label: 'Delegated Rules',
        description: 'View and manage delegated approval rules for your team.',
      },
      failedApiReports: {
        label: 'Failed API Reports',
        description:
          'Review failed integrations and retry operational message flows.',
      },
      emailConfiguration: {
        label: 'Email Configuration',
        description: 'Configure email preference types and notification behavior.',
      },
      slaConfiguration: {
        title: 'SLA Configuration',
        label: 'SLA Configuration',
        description: 'Define service-level targets and escalation rules.',
        dialogs: {
          edit: 'Edit {{slaKey}}',
        },
        fields: {
          goalValue: 'Goal Value',
          deadlineValue: 'Deadline Value',
          passedDeadlineValue: 'Passed Deadline Value',
          maxRepeatEvents: 'Max Repeat Events',
          isBusinessDay: 'Only calculate using business days',
        },
        placeholders: {
          value: 'Enter a value',
        },
        messages: {
          saved: 'SLA configuration saved successfully.',
        },
        errors: {
          loadFailed: 'Failed to load SLA configuration.',
          saveFailed: 'Failed to save SLA configuration.',
        },
        items: {
          AlsSteward: {
            description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
          },
          LandSteward: {
            description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
          },
          PlannerSteward: {
            description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
          },
        },
      },
      activeScheduleDistribution: {
        label: 'Active Schedule Distribution',
        description: 'Maintain recipients for active schedule distribution.',
      },
      dailyReportDistribution: {
        label: 'Daily Report Distribution',
        description: 'Manage the mailing list for daily operational reports.',
      },
      finalReportDistribution: {
        label: 'Final Report Distribution',
        description: 'Control who receives finalized reporting packages.',
      },
      distributionList: {
        label: 'Distribution List',
        description: 'Browse and maintain reusable distribution groups.',
      },
      highVolume: {
        label: 'High Volume',
        description: 'Review archived high-volume job references and history.',
      },
      complexWork: {
        label: 'Complex Work',
        description: 'Access historical records for complex work programs.',
      },
      rigless: {
        label: 'Rigless',
        description: 'View past rigless job information and reference material.',
      },
      inspections: {
        label: 'Inspections',
        description: 'Reference prior inspection work and outcomes.',
      },
      plugAndAbandon: {
        label: 'Plug & Abandon',
        description: 'Browse historical plug and abandonment jobs.',
      },
      reclamations: {
        label: 'Reclamations',
        description: 'Access historical reclamation job references.',
      },
      facilitiesDecom: {
        label: 'Facilities Decom',
        description: 'Review historical facilities decommissioning records.',
      },
      downloadFormTemplates: {
        label: 'Download Form Templates',
        description: 'Access standard form templates for repeatable workflows.',
      },
      plannerScope: {
        label: 'Planner Scope',
        description: 'Open scope templates used during planning activities.',
      },
      jobPlanTemplates: {
        label: 'Job Plan Templates',
        description: 'Browse reusable job plan starting points.',
      },
      peProcedure: {
        label: 'PE Procedure',
        description: 'Reference published PE procedures and supporting material.',
      },
      paProcedure: {
        label: 'PA Procedure',
        description: 'Reference published PA procedures and supporting material.',
      },
      longProcedures: {
        label: 'Long Procedures',
        description: 'Access longer-form procedural reference documents.',
      },
      modifyRigs: {
        label: 'Modify Rigs',
        description: 'Maintain rig-related configuration and supporting data.',
      },
      modifyScheduleCrews: {
        label: 'Modify Schedule Crews',
        description: 'Add and manage reclamation crew records.',
      },
      winCoordinators: {
        label: 'WIN Coordinators',
        description: 'Maintain WIN Coordinator email recipients for NM and TX.',
      },
      reclamation: {
        label: 'Reclamation',
        description: 'Manage Reclamation Team distribution recipients.',
      },
      rodTubingRetrieval: {
        label: 'Rod/Tubing Retrieval',
        description: 'Maintain Rod/Tubing Retrieval partner email recipients.',
      },
      titleClearanceRecipients: {
        label: 'Title Clearance Recipients',
        description: 'Maintain the Title Clearance recipient distribution list.',
      },
      pullRequests: {
        label: 'Pull Requests',
        description: 'View historical pull request job records.',
      },
      plugAndAbandonment: {
        label: 'Plug & Abandonment',
        description: 'Browse historical plug and abandonment jobs.',
      },
      facilityDecommission: {
        label: 'Facility Decommission',
        description: 'Review historical facilities decommissioning records.',
      },
    },
  },
  paProcedure: {
    title: 'PA Procedure Templates',
    addTemplate: 'Create New Template',
    empty: 'No templates found. Click Add Template to create one.',
    loadError: 'Failed to load PA Procedure templates.',
    saveSuccess: 'Template saved successfully.',
    saveError: 'Failed to save template.',
    copySuccess: 'Template copied successfully.',
    copyError: 'Failed to copy template.',
    deleteSuccess: 'Template deleted successfully.',
    deleteError: 'Failed to delete template.',
    public: 'Public',
    private: 'Private',
    tabs: {
      templates: 'PA Procedure Templates',
    },
    searchPlaceholder: 'Search by template name, FOT, or category',
    searchAriaLabel: 'Search PA Procedure templates',
    validation: {
      duplicateName: 'Template Name already exists.',
    },
    deleteConfirm: {
      title: 'Delete Template',
      message: 'Are you sure you want to delete the template <strong>"{{name}}"</strong>? This action cannot be undone.',
    },
    form: {
      titleAdd: 'Create PA Procedure Template',
      titleEdit: 'Edit PA Procedure Template',
      templateName: 'Template Name',
      fot: 'FOT',
      category: 'Category',
      isPublic: 'Public',
      procedureDependencies: 'Procedure Dependencies',
    },
    columns: {
      templateName: 'Template Name',
      fot: 'FOT',
      category: 'Category',
      isPublic: 'Visibility',
      createdBy: 'Created By',
      actions: 'Actions',
    },
    actions: {
      copy: 'Copy',
    },
  },
  slaConfiguration: {
    title: 'SLA Configuration',
    dialogs: {
      edit: '{{slaKey}} SLA',
    },
    fields: {
      goalValue: 'Goal Value',
      deadlineValue: 'Deadline Value',
      passedDeadlineValue: 'Passed Deadline Value',
      maxRepeatEvents: 'Max Repeat Events',
      isBusinessDay: 'Only calculate using business days',
    },
    placeholders: {
      value: 'Enter a value',
    },
    messages: {
      saved: 'SLA configuration saved successfully.',
    },
    errors: {
      loadFailed: 'Failed to load SLA configuration.',
      saveFailed: 'Failed to save SLA configuration.',
    },
    items: {
      AlsSteward: {
        description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
      },
      LandSteward: {
        description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
      },
      PlannerSteward: {
        description: 'Edit goalValue, deadlineValue, passedDeadlineValue, maxRepeatEvents',
      },
    },
  },
  modifyRigs: {
    title: 'Modify Rigs',
    subtitle: 'Manage rig records that are currently available or unavailable for scheduling.',
    sections: {
      addRig: 'Add Rig',
      available: 'Available Rigs',
      unavailable: 'Unavailable Rigs',
    },
    columns: {
      name: 'Rig Name',
      rigType: 'Rig Type',
      status: 'Status',
      actions: 'Actions',
    },
    form: {
      name: 'Rig Name',
      rigType: 'Rig Type',
      placeholderName: 'Enter rig name',
      placeholderRigType: 'Select Rig Type',
    },
    search: {
      label: 'Search Rigs',
      placeholder: 'Search available and unavailable rigs',
    },
    status: {
      available: 'Available',
      unavailable: 'Unavailable',
    },
    actions: {
      addRig: 'Add Rig',
      saveRig: 'Save Rig',
      editRigType: 'Edit Rig Type',
      saveRigType: 'Save Rig Type',
      cancelEdit: 'Cancel',
      makeUnavailable: 'Make Unavailable',
      reactivate: 'Make Available',
    },
    messages: {
      addSuccess: 'Rig added successfully.',
      updateSuccess: 'Rig Type updated successfully.',
      deactivateSuccess: 'Rig made unavailable successfully.',
      reactivateSuccess: 'Rig made available successfully.',
      deleteSuccess: 'Rig deleted successfully.',
    },
    errors: {
      loadFailed: 'Failed to load rigs.',
      addFailed: 'Failed to add rig.',
      updateFailed: 'Failed to update Rig Type.',
      deactivateFailed: 'Failed to make rig unavailable.',
      reactivateFailed: 'Failed to make rig available.',
      deleteFailed: 'Failed to delete rig.',
    },
    empty: {
      available: 'No available rigs found.',
      unavailable: 'No unavailable rigs found.',
    },
    dialogs: {
      editWarningTitle: 'Active Assignment Warning',
      editWarningMessage: 'Rig <strong>{{name}}</strong> currently has an active assignment. Continue saving the Rig Type change?',
      deactivateTitle: 'Make Rig Unavailable',
      deactivateMessage: 'Are you sure you want to make rig <strong>{{name}}</strong> unavailable?',
      deleteTitle: 'Delete Rig',
      deleteMessage: 'Are you sure you want to delete rig <strong>{{name}}</strong>? This action cannot be undone.',
    },
  },
  modifyScheduleCrews: {
    title: 'Modify Schedule Crews',
    subtitle: 'Add and maintain active schedule crews used for reclamation planning.',
    sections: {
      addCrew: 'Add New Schedule Crew',
      activeCrews: 'Active Schedule Crews',
    },
    columns: {
      name: 'Name',
      type: 'Type',
      actions: 'Actions',
    },
    form: {
      name: 'Crew Name',
      type: 'Crew Type',
      placeholderName: 'Enter crew name',
      fixedType: 'Reclamation Crew',
    },
    actions: {
      addCrew: 'Add Item',
      saveCrew: 'Save',
      cancel: 'Cancel',
    },
    messages: {
      addSuccess: 'Schedule crew added successfully.',
      deleteSuccess: 'Schedule crew deleted successfully.',
      duplicateCrew: 'This schedule crew already exists.',
    },
    errors: {
      loadFailed: 'Failed to load schedule crews.',
      addFailed: 'Failed to add schedule crew.',
      deleteFailed: 'Failed to delete schedule crew.',
    },
    dialogs: {
      deleteTitle: 'Delete Schedule Crew',
      deleteMessage: 'Are you sure you want to delete schedule crew <strong>{{name}}</strong>? This action cannot be undone.',
    },
    empty: 'No active schedule crews were found.',
  },
  distributionRecipientsPage: {
    fields: {
      email: 'Email',
      location: 'Location',
    },
    placeholders: {
      email: 'Enter an email address',
    },
    columns: {
      email: 'Email',
      location: 'Location',
      status: 'Status',
    },
    status: {
      active: 'Active',
      pendingDelete: 'Pending Delete',
    },
    actions: {
      addRecipient: 'Add Recipient',
      searchUsers: 'Search Users',
      undo: 'Undo',
      discard: 'Discard Changes',
    },
    messages: {
      saved: 'Distribution recipients saved successfully.',
      recipientAlreadyExists: 'This recipient already exists.',
    },
    errors: {
      loadFailed: 'Failed to load distribution recipients.',
      saveFailed: 'Failed to save distribution recipients.',
      invalidEmail: 'One or more email addresses are invalid.',
    },
    empty: 'No recipients were found.',
    emptySearch: 'No users found.',
  },
  winCoordinatorsPage: {
    title: 'WIN Coordinators',
    fields: {
      state: 'State',
    },
    columns: {
      state: 'State',
      dependency: 'Dependency',
      recipient: 'Recipient',
    },
    actions: {
      addRecipient: 'Add Recipient',
      discard: 'Discard Changes',
    },
    messages: {
      saved: 'WIN coordinator recipients saved successfully.',
      recipientAlreadyExists: 'This recipient is already included for the selected state.',
    },
    errors: {
      loadFailed: 'Failed to load WIN coordinators.',
      saveFailed: 'Failed to save WIN coordinators.',
    },
    noRecipients: 'No recipients added',
    emptySearch: 'No users found.',
  },
  reclamationDistributionPage: {
    title: 'Reclamation Distribution',
  },
  rodTubingRetrievalDistributionPage: {
    title: 'Rod/Tubing Retrieval Distribution',
  },
  titleClearanceRecipientsPage: {
    title: 'Title Clearance Recipients',
  },
  allOpenCases: {
    title: 'All Open Cases',
    tabs: {
      openCases: 'Open Cases',
      wellLifecycleManagement: 'Well Lifecycle Management',
      emc: 'EMC',
      minorWork: 'Minor Work',
      bulkProcesses: 'Bulk Processes',
    },
    subTabs: {
      active: 'ACTIVE',
      closeOut: 'Close Out',
      uneconomic: 'Uneconomic',
    },
    table: {
      caseType: 'Case Type',
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      status: 'Status',
      stepLabel: 'Step Label',
      createDate: 'Create Date',
    },
    filters: {
      caseType: 'Case Type',
      fot: 'FOT',
      allCaseTypes: 'All Case Types',
      allFots: 'All FOTs',
    },
  },
  closeOutPage: {
    title: 'Close Out',
    tabs: {
      pullRequests: 'Pull Requests',
      rigless: 'Rigless',
      plugAbandonment: 'Plug & Abandonment',
    },
    rigless: {
      searchPlaceholder: 'Enter search keyword',
      empty: 'No close out cases match the current search.',
      table: {
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        gaugerBeat: 'Gauger Beat',
        sectionName: 'Section Name',
        failureDate: 'Failure Date',
        downtimeCode: 'Downtime Code',
        daysInCurrentStep: 'Days in Current Step',
        createDate: 'Create Date',
      },
    },
  },
  nonRigPage: {
    title: 'Non-Rig',
    tabs: {
      jobs: 'Non-Rig',
    },
    filters: {
      status: 'Job Status',
      open: 'Open',
      closed: 'Close',
    },
    jobs: {
      searchPlaceholder: 'Enter search keyword',
      empty: 'No non-rig cases found.',
      viewAll: 'View All',
      table: {
        caseId: 'Case ID',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        status: 'Status',
        createDate: 'Create Date',
      },
    },
  },
  nonRigJobDetails: {
    title: 'Non-Rig Job Details',
    placeholder:
      'This placeholder route has been added so the Non-Rig well link can carry the case context until the final details form is defined.',
  },
  nrWorkflow: {
    caseList: {
      columns: {
        caseNumber: 'Case Number',
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        caseStatus: 'Status',
        createdDate: 'Created Date',
        closedDate: 'Closed Date',
        actions: 'Actions',
      },
    },
    openJobs: {
      title: 'Non-Rig — Open Jobs',
      empty: 'No open Non-Rig jobs found.',
      loadError: 'Failed to load open jobs. Please try again.',
    },
    closedJobs: {
      title: 'Non-Rig — Closed Jobs',
      empty: 'No closed Non-Rig jobs found.',
      loadError: 'Failed to load closed jobs. Please try again.',
    },
    caseForm: {
      title: 'Non-Rig Case',
      badge: 'Create Job',
      notFound: 'Case not found.',
      readOnlyNotice: 'This case is closed and cannot be edited.',
      suspendedNotice: 'Suspended',
      savedSuccess: 'Case saved successfully.',
      submittedSuccess: 'Case submitted successfully.',
      suspendedSuccess: 'Case suspended.',
      completedSuccess: 'Case completed.',
      cancelledSuccess: 'Case cancelled.',
      deletedSuccess: 'Case deleted.',
      conservationClear: 'No protected species concerns found.',
      conservationWarning: 'Protected Species Concern',
      conservationCheckButton: 'Check Conservation Status',
      sections: {
        wellInfo: 'Well Information',
        jobDetails: 'Job Details',
      },
      fields: {
        wellName: 'Well Name',
        api14: 'API 14',
        state: 'State',
        area: 'Area',
        fot: 'FOT',
        liftMethod: 'Lift Method',
        costCenter: 'Cost Center',
        plantCode: 'Plant Code',
        companyCode: 'Company Code',
        latitude: 'Latitude',
        longitude: 'Longitude',
        directionsToWell: 'Directions to Well',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        jobDriver: 'Job Driver',
        jobStatus: 'Job Status',
        startDate: 'Start Date',
        endDate: 'End Date',
        afe: 'AFE',
        plannedCost: 'Planned Cost',
        actualJobCost: 'Actual Job Cost',
        remarks: 'Remarks',
      },
      actions: {
        submit: 'Submit',
        suspend: 'Suspend',
        cancel: 'Cancel Job',
        complete: 'Complete',
      },
      validation: {
        title: 'Complete Required Fields',
        description: 'Enter the required fields below before saving this case.',
        dismiss: 'ok',
      },
    },
    caseDetail: {
      title: 'Non-Rig Case Detail',
      notFound: 'Case not found.',
      reopenButton: 'Reopen',
      reopenedSuccess: 'Case reopened successfully.',
      closedBy: 'Closed by',
      fields: {
        actualDuration: 'Actual Duration',
      },
    },
  },
  nonRigPageViewAll: 'View All',
  createReview: {
    title: 'Job Management',
    tabs: {
      singleCase: 'Single Case',
      bulkCreation: 'Bulk Creation',
      jobManagement: 'Job Management',
    },
    workTabs: {
      wellWork: 'Well Work',
      facilityWork: 'Facility Work',
    },
    wellSearch: {
      label: 'Well Search',
      placeholder: 'Search by API14, Well Name, or FOT...',
      clearButton: 'Clear Search',
    },
    caseType: {
      label: 'Select Case Type',
      placeholder: '-- Select Case Type --',
      createButton: 'Create Case',
    },
    createCaseDialog: {
      caseTypeLabel: 'Case Type',
      placeholder: 'Select Case Type',
      facilityNameLabel: 'Facility Name',
      facilityIdLabel: 'Facility ID',
      chevNoLabel: 'Chevno',
      errors: {
        noFotClassification:
          'This well has no FOT classification. Casing Events cases cannot be created without an FOT assignment.',
        fotCheckFailed:
          'Failed to verify FOT classification. Please try again.',
        createFailed:
          'Failed to create the case. Please try again.',
        facilityNameRequired: 'Facility Name is required.',
      },
      options: {
        well: {
          actionItems: 'Action Items',
          casingEvents: 'Casing Events',
          firstArtificialLift: 'First Artificial Lift',
          wellServicePullRequestOld: 'Well Service Pull Request - Old',
          nonRig: 'Non-Rig',
          plugAndAbandonment: 'Plug & Abandonment',
          popJobs: 'POP Jobs',
          wlmPullRequest: 'WLM Pull Request',
          reclamation: 'Reclamation',
          rigless: 'Rigless',
          wellheadInspection: 'Wellhead Inspection',
        },
        facility: {
          facilityDecommission: 'Facility Decommission',
          reclamation: 'Reclamation',
        },
      },
    },
    missingWell: {
      label: 'Missing Well Case Create',
      placeholder: 'Select Job Type',
    },
    wellInfo: {
      title: 'Well Information',
      wellName: 'Well Name',
      wellViewName: 'WellView Name',
      api14: 'API 14',
      state: 'State',
      fot: 'FOT',
      area: 'Area',
    },
    searchResultFields: {
      wellName: 'Well Name',
      wellViewName: 'WellView Name',
      api14: 'API14',
      fot: 'FOT',
      area: 'Area',
    },
    jobManagementPage: {
      wellDetailsTitle: 'Well Details',
      jobsTitle: 'Job History',
      jobHistorySearchPlaceholder: 'Enter Search keyword',
      selectWell: 'Select a well from search results.',
      actions: {
        createCase: 'Create',
        createWellCase: 'Well Work',
        createFacilityCase: 'Facility Work',
        toggleDetails: 'Toggle job details',
        hasAttachments: 'Case has attachments',
      },
      messages: {
        selectWellBeforeCreateWellWork:
          'Select a well from search before creating Well Work.',
      },
      details: {
        detailsTitle: 'Details',
        remarksLabel: 'Remarks',
        statusTitle: 'Status',
        jobStatusLabel: 'Job Status',
        statusChangeDateLabel: 'Status Change Date',
        statusChangeUserLabel: 'Status Change User',
        economicsTitle: 'Economics',
        afeLabel: 'AFE',
        plannedCostLabel: 'Planned Cost',
        actualJobCostLabel: 'Actual Job Cost',
        linkedCasesTitle: 'Linked Cases',
      },
      wellColumns: {
        fot: 'FOT',
        wellName: 'Well Name',
        wellViewName: 'Well Name Well View',
        api14: 'API 14',
        area: 'Area',
        sectionName: 'Section Name',
        gaugerBeat: 'Gauger Beat',
      },
      jobColumns: {
        caseId: 'Case ID',
        localReferenceNumber: 'Local Reference Number',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        startDate: 'Start Date',
        endDate: 'End Date',
        jobDurationDays: 'Job Duration (Days)',
        currentCentaurStep: 'Current Centaur Step',
        caseType: 'Case Type',
      },
    },
    activeJobs: {
      title: 'Active Jobs on Well',
      searchPlaceholder: 'Search jobs...',
      caseId: 'Case ID',
      createDate: 'Create Date',
      updateDate: 'Update Date',
      status: 'Status',
      jobReason: 'Job Reason',
      caseType: 'Case Type',
    },
  },
  pullRequest: {
    title: 'Pull Request Case',
    caseId: 'Case ID',
    openPRWarning: 'There is already an open Pull Request case',
    stages: {
      troubleshooting: 'Troubleshooting',
      landPEReview: 'Land & PE Review',
      wlmReview: 'WLM Review',
      preScheduling: 'Pre Scheduling',
      activeScheduling: 'Active Scheduling',
      jobCloseOut: 'Job Close Out',
      completion: 'Completion',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      state: 'State',
      area: 'Area',
      costCenter: 'Cost Center',
      plantCode: 'Plant Code',
      companyCode: 'Company Code',
      latitude: 'Latitude',
      longitude: 'Longitude',
      oilBopd: 'Oil (BOPD)',
      waterBwpd: 'Water (BWPD)',
      gasMcfpd: 'Gas (MCFPD)',
      wbsNumber: 'WBS Number',
      proactiveReactive: 'Proactive / Reactive',
      reasonForPull: 'Reason for Pull',
      liftMethod: 'Lift Method',
      failureDate: 'Failure Date',
      wellviewJobId: 'Wellview Job ID',
      wellviewJobType: 'Wellview Job Type',
      wellviewJobCreationDate: 'Wellview Job Creation Date',
      workDescription: 'Work Description',
      wellInfo: 'Well Information',
      previousWork: 'Previous Work',
      capStringInstalled: 'Cap String Installed',
      surfaceCasingGrade: 'Surface Casing Below or Above Grade',
      lastDeadManTestDate: 'Last Dead Man Test Date',
      plungerSubsurfaceEquipment: 'Plunger/Subsurface Equipment',
      isQciDisconnected: 'QCI Disconnected',
      currentRodRotator: 'Current Rod Rotator',
      currentTubingRotator: 'Current Tubing Rotator',
      pumpingUnitManufactureDescription: 'Pumping Unit Manufacture/Description',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Complete the required fields below before submitting for review.',
      fotUnknown: 'FOT — cannot be UNKNOWN, please select a valid FOT',
    },
    messages: {
      prCaseComplete: 'Thank you. The PR case is complete.',
    },
    dialogs: {
      reopenCloseOut: {
        message: 'Are you sure you want to reopen this case to Job Close Out?',
        submit: 'Submit',
      },
    },
  },
  rigless: {
    title: 'Rigless Case',
    stages: {
      troubleshooting: 'Troubleshooting',
      landReview: 'Land Review',
      wlmReview: 'WLM Review',
      preScheduling: 'Pre Scheduling',
      activeScheduling: 'Active Scheduling',
      jobCloseOut: 'Job Close Out',
      completion: 'Completion',
    },
  },
  casingPressure: {
    title: 'Casing Pressure Case',
  },
  casingPressureInitialReading: {
    title: 'Casing Pressure Initial Reading',
    selectPlaceholder: '-select-',
    stages: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      complete: 'Complete',
    },
    sections: {
      wellInformation: 'Well Information',
      initialReading: 'Initial Reading',
      attachments: 'Attachments',
    },
    fields: {
      wellName: 'Well Name',
      area: 'Area',
      wellTest1: 'Well Test 1 (BOED)',
      api14: 'API 14',
      fot: 'FOT',
      wellTest2: 'Well Test 2 (BOED)',
      chevno: 'Chevno',
      gaugerBeatCode: 'Gauger Beat Code',
      wellTest3: 'Well Test 3 (BOED)',
      costCenter: 'Cost Center',
      sectionName: 'Section Name',
      hcpRiskRanking: 'HCP Risk Ranking',
      readingType: 'Reading Type',
      datePressureRecorded: 'Date Pressure Recorded',
      wellStatus: 'Well Status',
      bradenHeadSurfacePressure: 'Bradenhead Surface Pressure',
      intermediateCasingPressure: 'Intermediate Casing Pressure',
      productionCasingPressure: 'Production Casing Pressure',
      comment: 'Comment',
    },
    readingTypes: {
      initialReading: 'Initial Reading',
    },
    attachments: {
      attachNew: 'Attach New',
    },
    actions: {
      moveToVerification: 'Move to Verification',
      saved: 'Initial reading saved successfully.',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Enter the required fields below before moving to the next step.',
    },
  },
  casingPressureDialogs: {
    header: {
      attachments: 'Attachments',
      viewAttachments: 'View Attachments',
    },
    attachments: {
      title: 'Attachments',
      dropCopy: 'Drop files here or use the file picker below.',
      selectFiles: 'Select Files',
    },
    attachmentDetails: {
      title: 'Attachment Details',
      columns: {
        fileName: 'File Name',
        category: 'Category',
        uploadedBy: 'Uploaded By',
        uploadedOn: 'Uploaded On',
        size: 'Size',
      },
    },
  },
  casingPressureVerification: {
    title: 'Casing Pressure Verification',
    entryTitle: 'Verification',
    subtitle: 'Review initial readings and record verification pressure data.',
    selectPlaceholder: '-select-',
    header: {
      relatedCases: 'Related Cases',
    },
    stages: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      complete: 'Complete',
    },
    sections: {
      wellInformation: 'Well Information',
      verification: 'Verification',
      initialReading: 'Initial Reading',
      attachments: 'Attachments',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      area: 'Area',
      fot: 'FOT',
      chevno: 'Chevno',
      gaugerBeatCode: 'Gauger Beat Code',
      costCenter: 'Cost Center',
      sectionName: 'Section Name',
      wellTest1: 'Well Test 1 (BOED)',
      wellTest2: 'Well Test 2 (BOED)',
      wellTest3: 'Well Test 3 (BOED)',
      hcpRiskRanking: 'HCP Risk Ranking',
      scpRiskRanking: 'SCP Risk Ranking',
      readingType: 'Reading Type',
      datePressureRecorded: 'Date Pressure Recorded',
      bradenHeadSurfacePressure: 'Bradenhead Surface Pressure',
      intermediateCasingPressure: 'Intermediate Casing Pressure',
      productionCasingPressure: 'Production Casing Pressure',
      wellStatus: 'Well Status',
      comment: 'Comment',
      time: 'Time',
      sampleCollected: 'Sample Collected',
    },
    readingTypes: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
    },
    attachments: {
      title: 'Attachments',
      attachNew: 'Attach New',
    },
    actions: {
      addRow: 'Add a row',
      moveToMitigation: 'Move to Mitigation',
      saved: 'Verification saved successfully.',
    },
    deleteRowDialog: {
      title: 'Deleting Verification Entry',
      confirmTitle: 'Please Confirm',
      message: 'Do you want to remove this verification entry?',
      cancel: 'Cancel',
      confirm: 'Remove Entry',
      closeLabel: 'Close dialog',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Enter the required fields below before moving to the next step.',
      rowFieldRequired: 'This field is required.',
      rowPrefix: 'Verification Row {{row}}',
      atLeastOneRow: 'At least one verification row is required.',
    },
  },
  cpAttachments: {
    categories: {
      file: 'File',
      mitigationPlan: 'Mitigation Plan',
    },
  },
  casingPressureMitigation: {
    title: 'Casing Pressure Mitigation',
    entryTitle: 'Mitigation',
    subtitle: 'Define and track mitigation actions for the casing pressure case.',
    selectPlaceholder: '-select-',
    header: {
      relatedCases: 'Related Cases',
    },
    stages: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      complete: 'Complete',
    },
    sections: {
      wellInformation: 'Well Information',
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      attachments: 'Attachments',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      area: 'Area',
      fot: 'FOT',
      chevno: 'Chevno',
      gaugerBeatCode: 'Gauger Beat Code',
      costCenter: 'Cost Center',
      sectionName: 'Section Name',
      wellTest1: 'Well Test 1 (BOED)',
      wellTest2: 'Well Test 2 (BOED)',
      wellTest3: 'Well Test 3 (BOED)',
      hcpRiskRanking: 'HCP Risk Ranking',
      scpRiskRanking: 'SCP Risk Ranking',
      readingType: 'Reading Type',
      datePressureRecorded: 'Date Pressure Recorded',
      bradenHeadSurfacePressure: 'Bradenhead Surface Pressure',
      intermediateCasingPressure: 'Intermediate Casing Pressure',
      productionCasingPressure: 'Production Casing Pressure',
      wellStatus: 'Well Status',
      comment: 'Comment',
      time: 'Time',
      sampleCollected: 'Sample Collected',
      productionEngineer: 'Production Engineer',
      date: 'Date',
      dueDate: 'Due Date',
      action: 'Action',
      responsiblePerson: 'Responsible Person',
      status: 'Status',
      name: 'Name',
      role: 'Role',
      approvalDate: 'Approval Date',
      approvalComments: 'Approval Comments',
      approverFeedback: 'Approver Feedback',
    },
    readingTypes: {
      initialReading: 'Initial Reading',
    },
    attachments: {
      attachMitigationPlan: 'Attach Mitigation Plan',
      mitigationPlanMissing: 'Mitigation plan is not attached.',
      title: 'Attachments',
      attachNew: 'Attach New',
    },
    actions: {
      moveToApproval: 'Move to Approval',
      saved: 'Mitigation saved successfully.',
      addRow: 'Add Row',
    },
    deleteRowDialog: {
      title: 'Deleting Mitigation Entry',
      confirmTitle: 'Please Confirm',
      message: 'Do you want to remove this mitigation entry?',
      cancel: 'Cancel',
      confirm: 'Remove Entry',
      closeLabel: 'Close dialog',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Enter the required fields below before moving to the next step.',
      rowPrefix: 'Mitigation Row {{row}}',
      verificationRowPrefix: 'Verification Row {{row}}',
      atLeastOneRow: 'At least one mitigation row is required.',
      atLeastOneVerificationRow: 'At least one verification row is required.',
    },
    messages: {
      peUserNotFound: 'Production Engineer user cannot be found.',
    },
  },
  casingPressureApproval: {
    title: 'Casing Pressure Approval',
    entryTitle: 'Approval',
    subtitle: 'Review mitigation details and submit casing pressure approval.',
    selectPlaceholder: '-select-',
    header: {
      relatedCases: 'Related Cases',
    },
    stages: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      complete: 'Complete',
    },
    sections: {
      wellInformation: 'Well Information',
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      attachments: 'Attachments',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      area: 'Area',
      fot: 'FOT',
      chevno: 'Chevno',
      gaugerBeatCode: 'Gauger Beat Code',
      costCenter: 'Cost Center',
      sectionName: 'Section Name',
      wellTest1: 'Well Test 1 (BOED)',
      wellTest2: 'Well Test 2 (BOED)',
      wellTest3: 'Well Test 3 (BOED)',
      hcpRiskRanking: 'HCP Risk Ranking',
      scpRiskRanking: 'SCP Risk Ranking',
      readingType: 'Reading Type',
      datePressureRecorded: 'Date Pressure Recorded',
      bradenHeadSurfacePressure: 'Bradenhead Surface Pressure',
      intermediateCasingPressure: 'Intermediate Casing Pressure',
      productionCasingPressure: 'Production Casing Pressure',
      wellStatus: 'Well Status',
      comment: 'Comment',
      time: 'Time',
      sampleCollected: 'Sample Collected',
      productionEngineer: 'Production Engineer',
      date: 'Date',
      dueDate: 'Due Date',
      action: 'Action',
      responsiblePerson: 'Responsible Person',
      status: 'Status',
      name: 'Name',
      role: 'Role',
      approvalDate: 'Approval Date',
      approvalComments: 'Approval Comments',
      approverFeedback: 'Approver Feedback',
    },
    readingTypes: {
      initialReading: 'Initial Reading',
    },
    attachments: {
      attachMitigationPlan: 'Attach Mitigation Plan',
      mitigationPlanMissing: 'Mitigation plan is not attached.',
      title: 'Attachments',
      attachNew: 'Attach New',
    },
    actions: {
      sendNotification: 'Send Notification',
      submit: 'Submit',
      saved: 'Approval saved successfully.',
      addRow: 'Add Row',
    },
    validation: {
      title: 'Complete Required Fields',
      description: 'Enter the required fields below before moving to the next step.',
      rowFieldRequired: 'This field is required.',
      rowPrefix: 'Approval Row {{row}}',
      verificationRowPrefix: 'Verification Row {{row}}',
      mitigationRowPrefix: 'Mitigation Row {{row}}',
      atLeastOneRow: 'At least one approval row is required.',
      atLeastOneVerificationRow: 'At least one verification row is required.',
      atLeastOneMitigationRow: 'At least one mitigation row is required.',
    },
    deleteRowDialog: {
      title: 'Deleting Approval Entry',
      confirmTitle: 'Please Confirm',
      message: 'Do you want to remove this approval entry?',
      cancel: 'Cancel',
      confirm: 'Remove Entry',
      closeLabel: 'Close dialog',
    },
    messages: {
      peUserNotFound: 'Production Engineer user cannot be found.',
    },
    notifications: {
      sent: 'Approval notification sent successfully.',
    },
  },
  casingPressureCompletion: {
    entryTitle: 'Completion',
    readingTypes: {
      initialReading: 'Initial Reading',
    },
    thankYou: 'Thank you. The casing pressure case is complete.',
    header: {
      relatedCases: 'Related Cases',
      editCpDetails: 'Edit CP Details',
    },
    status: {
      resolvedCompleted: 'Resolved / Completed',
      resolvedError: 'Resolved / Error',
      resolvedDivest: 'Resolved / Divest',
      resolvedNotNeeded: 'Resolved / Not Needed',
    },
    stages: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      complete: 'Complete',
    },
    sections: {
      wellInformation: 'Well Information',
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      area: 'Area',
      fot: 'FOT',
      chevno: 'Chevno',
      gaugerBeatCode: 'Gauger Beat Code',
      costCenter: 'Cost Center',
      sectionName: 'Section Name',
      wellTest1: 'Well Test 1 (BOED)',
      wellTest2: 'Well Test 2 (BOED)',
      wellTest3: 'Well Test 3 (BOED)',
      hcpRiskRanking: 'HCP Risk Ranking',
      scpRiskRanking: 'SCP Risk Ranking',
      readingType: 'Reading Type',
      datePressureRecorded: 'Date Pressure Recorded',
      bradenHeadSurfacePressure: 'Bradenhead Surface Pressure',
      bradenPressure: 'Bradenhead Surface Pressure',
      intermediateCasingPressure: 'Intermediate Casing Pressure',
      intermediatePressure: 'Intermediate Casing Pressure',
      productionCasingPressure: 'Production Casing Pressure',
      productionPressure: 'Production Casing Pressure',
      wellStatus: 'Well Status',
      comment: 'Comment',
      time: 'Time',
      sampleCollected: 'Sample Collected',
      productionEngineer: 'Production Engineer',
      date: 'Date',
      dueDate: 'Due Date',
      action: 'Action',
      responsiblePerson: 'Responsible Person',
      status: 'Status',
      name: 'Name',
      role: 'Role',
      approvalDate: 'Approval Date',
      approvalComments: 'Approval Comments',
      approverFeedback: 'Approver Feedback',
    },
    reopenDialog: {
      title: 'Reopen Case',
      closeLabel: 'Close reopen dialog',
      message: 'Are you sure you want to reopen this casing pressure case?',
      cancel: 'Cancel',
      submit: 'Reopen',
    },
  },
  casingPressureQueue: {
    title: 'Casing Pressure',
    searchAriaLabel: 'Search casing pressure queue',
    searchPlaceholder: 'Enter search keyword',
    statusLabel: 'Job Status',
    statusPlaceholder: 'Select status',
    viewAll: 'View All',
    empty: 'No casing pressure cases found.',
    paginationLabel: 'Casing pressure queue pagination',
    pageTitle: 'Page {{page}}',
    tabs: {
      jobs: 'Casing Pressure',
    },
    statuses: {
      initialReading: 'Initial Reading',
      verification: 'Verification',
      mitigation: 'Mitigation',
      approval: 'Approval',
      closed: 'Closed',
      resolvedCompleted: 'Resolved Completed',
      resolvedError: 'Resolved - Duplicate/Human Error',
      resolvedDivest: 'Resolved - Well Divested',
      resolvedNotNeeded: 'Resolved - Not Needed',
    },
    table: {
      actions: 'Actions',
      caseId: 'Case ID',
      wellName: 'Well Name',
      fot: 'FOT',
      status: 'Status',
      createdDate: 'Create Date',
      createdBy: 'Created By',
    },
  },
  facilityDecommissionQueue: {
    title: 'Facility Decommission',
    searchAriaLabel: 'Search facility decommission queue',
    searchPlaceholder: 'Enter search keyword',
    statusLabel: 'Job Status',
    statusPlaceholder: 'Select status',
    viewAll: 'View All',
    empty: 'No facility decommission cases found.',
    tabs: {
      jobs: 'Facility Decommission',
    },
    statuses: {
      projectDataEntry:        'Project Data Entry',
      environmentalLandReview: 'Environmental & Land Review',
      environmentalReview:     'Environmental Review',
      landReview:              'Land Review',
      siteScoping:         'Site Scoping',
      scopeReview:         'Scope Review',
      afe:                 'AFE',
      eamAndPermitting:    'Workorders & Permitting',
      eam:                 'Workorders',
      projectPermitting:   'Project Permitting',
      digPlan:             'Dig Plan',
      digPlanCreation:     'Dig Plan Creation',
      digPlanApproval:     'Dig Plan Approval',
      digPlanExecution:    'Dig Plan Execution',
      scheduling:          'Scheduling',
      activeSchedule:      'Active Schedule',
      jobCloseOut:         'Job Close Out',
    },
    table: {
      caseId:             'Case ID',
      facilityName:       'Facility Name',
      fot:                'FOT',
      status:             'Status',
      daysInCurrentStep:  'Days in Current Step',
      createdDate:        'Create Date',
    },
  },
  cpReopenCpCase: {
    title: 'Reopen CP Case',
    confirmTitle: 'Please Confirm',
    message: 'Are you sure you want to take this action? Proceeding will reopen the case allowing you to resubmit CP case details.',
    actions: {
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
  cpCancelCase: {
    title: 'Cancel Case',
    reasonLabel: 'Cancellation Reason',
    reasonPlaceholder: 'Select a reason',
    commentsLabel: 'Comments',
    commentsPlaceholder: 'Provide details for the cancellation',
    reasons: {
      duplicateHumanError: 'Duplicate/Human Error',
      wellDivested: 'Well Divested',
      notNeeded: 'Not Needed',
    },
    actions: {
      cancel: 'Close',
      confirm: 'Cancel Case',
    },
    messages: {
      success: 'Case has been cancelled.',
    },
  },
  reclamationQueue: {
    title: 'Reclamation',
    searchAriaLabel: 'Search reclamation queue',
    searchPlaceholder: 'Enter search keyword',
    stageLabel: 'Stage',
    stagePlaceholder: 'Select stage',
    viewAll: 'View All',
    empty: 'No reclamation cases found.',
    paginationLabel: 'Reclamation queue pagination',
    pageTitle: 'Page {{page}}',
    tabs: {
      jobs: 'Reclamation',
    },
    statuses: {
      fieldReview: 'Field Review',
      remediation: 'Remediation',
      surfaceRestoration: 'Surface Restoration',
      inspection: 'Inspection',
      closed: 'Closed',
    },
    stages: {
      digPlan: 'Dig Plan',
      reclamationScheduling: 'Reclamation Scheduling',
      seedingScheduling: 'Seeding Scheduling',
      activeScheduling: 'Active Scheduling',
      siteInspection: 'Site Inspection',
      jobCloseOut: 'Job Close Out',
    },
    table: {
      actions: 'Actions',
      caseId: 'Case ID',
      assetName: 'Asset Name',
      assetType: 'Asset Type',
      api14: 'API 14',
      wellName: 'Well Name',
      fot: 'FOT',
      legacyFot: 'Legacy FOT?',
      deadlineDate: 'Deadline Date',
      deadline: 'Deadline',
      seedingDeferralDate: 'Seeding Deferral Date',
      seedingDeferralComment: 'Seeding Deferral Comment',
      status: 'Status',
      createdDate: 'Create Date',
      createdBy: 'Created By',
      caseType: 'Case Type',
      scheduleWindow: 'Schedule Window',
      owner: 'Owner',
      priority: 'Priority',
      seedMix: 'Seed Mix',
      scheduledDate: 'Scheduled Date',
      contractor: 'Contractor',
      crew: 'Crew',
      state: 'State',
      queueOrder: 'Queue Order',
      scheduleType: 'Schedule Type',
      latitude: 'Latitude',
      longitude: 'Longitude',
      stageEntryDate: 'Stage Entry Date',
      daysInCurrentStep: 'Days in Current Step',
      fanSubmissionDate: 'FAN Submission Date',
      createDate: 'Create Date',
      startDate: 'Start Date',
      workScope: 'Work Scope',
      inspector: 'Inspector',
      inspectionDate: 'Inspection Date',
      result: 'Result',
      completedDate: 'Completed Date',
      closedBy: 'Closed By',
      closeOutStatus: 'Close Out Status',
    },
  },
  reclamationWorkflow: {
    stages: {
      create: 'Create',
      digPlan: 'Dig Plan',
      reclamationScheduling: 'Reclamation Scheduling',
      seedingScheduling: 'Seeding Pre-Scheduling',
      activeScheduling: 'Active Scheduling',
      siteInspection: 'Site Inspection',
      jobCloseOut: 'Job Close Out',
    },
    create: {
      title: 'Manually Create Reclamation',
      activeJobsNotice: 'Please review any active or uneconomic jobs on this well prior to creating a new case.',
      tabs: {
        create: 'Create Reclamation',
        activeJobs: 'Active Jobs',
      },
      fields: {
        wellName: 'Well Name',
        state: 'State',
        field: 'Field',
        fot: 'FOT',
        deadlineDate: 'Deadline Date',
        comments: 'Comments',
        skipDigPlan: 'Skip Dig Plan/Scheduling/Execution?',
      },
      skipWarningLine1: 'Selecting \'Skip Dig Plan/Scheduling/Execution?\' will move the case directly to Seeding Pre-Scheduling.',
      skipWarningLine2: 'The Reclamation Dig Plan, Pre-Schedule, and Execution stages will be skipped.',
      actions: {
        submit: 'Submit',
      },
    },
    activeJobs: {
      title: 'Active & Uneconomic Jobs on Well',
      searchPlaceholder: 'Enter search keyword',
      empty: 'No active or uneconomic jobs match the current search.',
      table: {
        caseId: 'Case ID',
        createDate: 'Create Date',
        updateDate: 'Update Date',
        status: 'Status',
        jobReason: 'Job Reason',
        caseType: 'Case type',
      },
    },
    digPlan: {
      badge: 'Dig Plan',
      tabs: {
        assetInformation: 'Asset Information',
        createDigPlan: 'Create Dig Plan',
        businessPartners: 'Business Partners',
      },
      summary: {
        fot: 'FOT',
        state: 'State',
        status: 'Status',
      },
      sections: {
        assetInformation: 'Asset Information',
        planDetails: 'Dig Plan Details',
        requirements: 'Planning Requirements',
        businessPartners: 'Business Partners',
      },
      asset: {
        wellName: 'Well Name',
        caseNumber: 'Case Number',
        state: 'State',
        fot: 'FOT',
        api14: 'API 14',
        field: 'Field',
      },
      fields: {
        status: 'Dig Plan Status',
        contractor: 'Contractor / Crew',
        plannedStartDate: 'Planned Start Date',
        plannedEndDate: 'Planned End Date',
        estimatedCost: 'Estimated Cost',
        scope: 'Scope of Work',
        comments: 'Comments',
      },
      requirements: {
        name: 'Requirement',
        owner: 'Owner',
        status: 'Status',
        dueDate: 'Due Date',
      },
      businessPartners: {
        add: 'Add business partner',
        email: 'Business Partner Email',
        noItems: 'No items',
      },
      attachments: {
        instructions: 'Please create & upload a Dig Plan. Then progress to the FSM Superintendent for approval.',
        attachAction: 'Attach Dig Plan',
        required: 'Dig Plan file is required before submitting for review.',
      },
      actions: {
        cancelJob: 'Cancel Job',
        submitForReview: 'Submit',
      },
    },
    dialogs: {
      cancel: {
        message: 'Cancel creating this reclamation case?',
      },
      rework: {
        comments: 'Rework Comments',
      },
      actions: {
        approve: 'Approve',
        rework: 'Send Back for Rework',
      },
    },
    messages: {
      preSchedulingSavedSuccess: 'Pre-Scheduling saved successfully.',
      digPlanReviewSavedSuccess: 'Dig Plan Review saved successfully.',
      siteInspectionSavedSuccess: 'Site Inspection saved successfully.',
      reclamationExecutionSavedSuccess: 'Reclamation Execution saved successfully.',
      closeOutSavedSuccess: 'Close Out saved successfully.',
      seedingSchedulingSavedSuccess: 'Seeding Pre-Scheduling saved successfully.',
      seedingExecutionSavedSuccess: 'Seeding Execution saved successfully.',
      saveError: 'Failed to save. Please try again.',
    },
  },
  reclamationExecution: {
    tooltips: {
      needsSeeding: 'New Mexico wells will always require seeding and site inspection.',
    },
  },
  submissions: {
    title: 'Submissions',
    placeholder: 'Coming soon',
    tabs: {
      pullRequests: 'Pull Requests',
      highVolume: 'High Volume',
      complexWork: 'Complex Work',
      fal: 'FAL',
      rigless: 'Rigless',
      plugAbandonment: 'Plug & Abandonment',
    },
    table: {
      ownership: 'Ownership',
      wellName: 'Well Name',
      fot: 'FOT',
      daysInCurrentStep: 'Days in Current Step',
      failureDate: 'Failure Date',
      createDate: 'Create Date',
    },
  },
  delegatedRules: {
    title: 'Delegated Rules',
    sections: {
      generic: 'Generic',
      assetRetirement: 'Asset Retirement',
      nonRig: 'Non Rig',
    },
    items: {
      dropdownOptions: {
        label: 'Dropdown Options',
        description: 'Manage generic dropdown configuration values.',
      },
      plantCodes: {
        label: 'Plant Codes',
        description: 'Manage plant code and company code mappings.',
      },
      schedulerValues: {
        label: 'Scheduler Values',
        description: 'Review and maintain scheduler configuration values.',
      },
      gaPercent: {
        label: 'G&A Percent',
        description: 'Maintain permanent G&A percent configuration.',
      },
      powerlineDistance: {
        label: 'Powerline Distance',
        description: 'Maintain permanent powerline distance configuration.',
      },
      nonRigDropdownOptions: {
        label: 'Non Rig Dropdown Options',
        description: 'Manage non-rig dropdown options by lookup group.',
      },
    },
    actions: {
      backToDataValues: 'Back to Data Values',
    },
    plantCodesPage: {
      title: 'Plant Codes',
      empty: 'No plant code rows found.',
      fields: {
        plantCode: 'Plant Code',
        companyCode: 'Company Code',
        description: 'Description',
      },
      placeholders: {
        plantCode: 'Enter plant code',
        companyCode: 'Enter company code',
        description: 'Enter description',
      },
      columns: {
        plantCode: 'Plant Code',
        companyCode: 'Company Code',
        description: 'Description',
        status: 'Status',
      },
      status: {
        active: 'Active',
        pendingDelete: 'Pending Delete',
      },
      actions: {
        addRow: 'Add Row',
        undo: 'Undo',
        discard: 'Discard',
      },
      messages: {
        duplicatePair: 'Plant Code and Company Code combination already exists.',
        saved: 'Plant codes were updated successfully.',
      },
      errors: {
        loadFailed: 'Unable to load plant codes.',
        saveFailed: 'Unable to save plant code changes.',
        requiredFields: 'Plant Code and Company Code are required for active rows.',
      },
    },
    gaPercentPage: {
      title: 'G&A Percent',
      fields: {
        value: 'Percent Value',
      },
      placeholders: {
        value: 'Enter a value from 0.00 to 100.00',
      },
      messages: {
        saved: 'G&A Percent was updated successfully.',
      },
      errors: {
        loadFailed: 'Unable to load G&A Percent value.',
        saveFailed: 'Unable to save G&A Percent value.',
      },
    },
    powerlineDistancePage: {
      title: 'Powerline Distance',
      fields: {
        value: 'Distance (feet)',
      },
      placeholders: {
        value: 'Enter a positive integer distance in feet',
      },
      messages: {
        saved: 'Powerline Distance was updated successfully.',
      },
      errors: {
        loadFailed: 'Unable to load Powerline Distance value.',
        saveFailed: 'Unable to save Powerline Distance value.',
        integerOnly: 'Powerline Distance must be a positive integer.',
      },
    },
    dropdownOptionsPage: {
      title: 'Generic Dropdown Options',
      empty: 'No dropdown options found for this category.',
      fields: {
        category: 'Category',
        value: 'Value',
        displayText: 'Display Text',
        dependencyGroup: 'Dependency Group',
        dependencyValue: 'Dependency Value',
      },
      placeholders: {
        category: 'Select a category',
        value: 'Enter value',
        displayText: 'Enter display text',
        dependencyGroup: 'Enter dependency group',
        dependencyValue: 'Enter dependency value',
      },
      columns: {
        value: 'Value',
        displayText: 'Display Text',
        dependencyGroup: 'Dependency Group',
        dependencyValue: 'Dependency Value',
        sortOrder: 'Sort Order',
        status: 'Status',
      },
      categories: {
        liftMethod: 'Lift Method',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        preScheduleStatus: 'Pre-Schedule Status',
        priorityIssue: 'Priority Issue',
      },
      status: {
        active: 'Active',
        new: 'New',
        pendingDelete: 'Pending Delete',
      },
      actions: {
        addRow: 'Add Row',
        undo: 'Undo',
        discard: 'Discard',
      },
      messages: {
        duplicateValue: 'Value already exists in the current staged list.',
        saved: 'Dropdown options were updated successfully.',
      },
      errors: {
        requiredValue: 'Value is required for active rows.',
        loadFailed: 'Unable to load dropdown options.',
        saveFailed: 'Unable to save dropdown option changes.',
      },
    },
    nonRigDropdownOptionsPage: {
      title: 'Non Rig Dropdown Options',
      categories: {
        nonRigJobType: 'Job Type - Non Rig',
        nonRigJobReason: 'Job Reason',
      },
    },
    views: {
      dropdownOptions: {
        title: 'Generic Dropdown Options',
        description: 'Manage generic dropdown categories with staged add, edit, pending delete, undo, submit, and discard.',
      },
      plantCodes: {
        title: 'Plant Codes',
        description: 'Phase 5.3 implementation will provide staged add, delete, undo, submit, and discard behavior.',
      },
      schedulerValues: {
        title: 'Scheduler Values',
        description: 'Phase 5.4 implementation is blocked by GAP-05 pending confirmed keys and control types.',
      },
      gaPercent: {
        title: 'G&A Percent',
        description: 'Phase 5.5 implementation will provide single-record edit and submit behavior.',
      },
      powerlineDistance: {
        title: 'Powerline Distance',
        description: 'Phase 5.5 implementation will provide single-record edit and submit behavior.',
      },
      nonRigDropdownOptions: {
        title: 'Non Rig Dropdown Options',
        description: 'Manage non-rig dropdown categories with staged add, edit, pending delete, undo, submit, and discard.',
      },
    },
  },
  reports: {
    title: 'Reports',
  },
  options: {
    title: 'Options',
  },
  profileConfiguration: {
    title: 'Profile Configuration',
    backToOptions: 'Back to Options',
    tabs: {
      emailPreferences: 'Email Preferences',
      fots: 'FOTs',
      workflowAssignments: 'Workflow Assignments',
      defaultDashboardTabs: 'Default Dashboard Tabs',
    },
    email: {
      personalSection: 'Personal email preference',
      fotSection: 'FOT email preference',
      correspondenceFor: 'Correspondence for:',
      tableColumnEmailPref: 'Email Preference',
      tableColumnEnable: 'Enable?',
      copyToWorkFots: 'Copy to Assigned Work FOTs',
      selectAll: 'Select All',
      fotsForWork: 'FOTs for work',
      fotsForNotification: 'FOTs for Notification',
    },
    setupIncomplete:
      'Welcome to Centaur. Please complete your profile setup by selecting your Field Operating Teams and notification preferences.',
    messages: {
      saved: 'Preferences saved successfully',
    },
    workflow: {
      infoText:
        'Select/unselect which workflows you need access to. Regardless of workflow selections your role is still considered when determining dashboard table, and assignment access.',
      infoExample:
        'E.g. An ALCE user (non power user) with the P&A workflow selected will not have access to any P&A assignments, but may have read-only access to P&A dashboards and tables.',
      selectionHeader: 'Workflow Selection',
      fotSection: 'FOTs for assigned work',
      copyToEmailFots: 'Copy to FOT Email Assignments',
      selectAll: 'Select All',
      activeFotList: 'Active FOT List',
      historicalFotList: 'Historical FOT List',
    },
    dashboard: {
      activeSchedule: 'Active Schedule',
      primaryTabLabel: 'Active Schedule - Primary Tab',
      selectPlaceholder: '-select-',
    },
    actions: {
      save: 'Save',
      saving: 'Saving...',
      saveAndUpdate: 'Save and Update',
      resetFotChanges: 'Reset FOT List Changes',
    },
  },
  helpDashboard: {
    title: 'Help Dashboard',
  },
  filterBar: {
    clearFilters: 'Clear Filters',
  },
  tableToolbar: {
    columnVisibility: 'Columns',
    searchPlaceholder: 'Search...',
  },
  serverError: {
    title: 'Server Error',
    message: 'An unexpected error occurred. Please try again later.',
    returnHome: 'Go to Home',
  },
  unauthorized: {
    title: 'Access Denied',
    defaultMessage: 'You do not have permission to access this page.',
    returnHome: 'Go to Home',
    support: {
      needHelp: 'Need help?',
      contactSupport: 'Contact Support',
      requestAccess: 'Request Access via ServiceNow',
    },
  },
  paginator: {
    previous: 'Previous',
    next: 'Next',
    currentPageReport:
      'Showing {{ currentInitialRow }} to {{ currentLastRow }} of {{ totalRecords }} entries',
    rowsPerPage: 'Rows per page',
    of: 'of',
  },
  footer: {
    copyright: 'Copyright',
    allRightsReserved: 'All rights reserved.',
  },
  userManagement: {
    title: 'User Management',
    sections: {
      searchUser: 'Find User',
      userDetails: 'User Details',
      teams: 'Team Assignments',
      fotAssignments: 'FOT Assignments',
    },
    labels: {
      searchUser: 'Search by name or email',
      searchPlaceholder: 'Type a name or email address...',
      name: 'Name',
      email: 'Email',
      jobTitle: 'Job Title',
      teamsDescription: 'Select one or more teams this user belongs to.',
      fotForEmail: 'FOT for Receiving Emails',
      fotForWork: 'FOT for Assigning Work',
      fotPlaceholder: 'Select FOTs...',
      refreshMembers: 'Refresh',
    },
    messages: {
      saved: 'User assignment saved successfully.',
    },
    errors: {
      searchFailed: 'Failed to search users. Please try again.',
      loadMembersFailed:
        'Failed to load application users. Please refresh the page.',
    },
  },
  myProfile: {
    sections: {
      identity: 'Identity',
      fotWork: 'FOTs for Work',
      fotNotifications: 'FOTs for Notifications',
      emailPreferences: 'Email Preferences',
    },
    labels: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      supervisor: 'Supervisor',
      lastLoginDate: 'Last Login',
      allFots: 'All FOTs',
      fotWork: 'FOTs for Work',
      fotNotifications: 'FOTs for Notifications',
      fotPlaceholder: 'Select FOTs...',
      notAvailable: 'N/A',
    },
    messages: {
      saved: 'Profile saved successfully.',
    },
  },
  adminUsersList: {
    title: 'User Management',
    sections: {
      users: 'Users',
    },
    actions: {
      addUser: 'Add User',
      exportTable: 'Export Table',
      edit: 'Edit',
    },
    columns: {
      name: 'Name',
      email: 'Email',
      role: 'Role',
      supervisor: 'Supervisor',
      fotsForWork: 'FOTs for Work',
      fotsForNotifications: 'FOTs for Notifications',
      lastLogin: 'Last Login',
      provisionDate: 'Provision Date',
      actions: 'Actions',
    },
    filters: {
      searchPlaceholder: 'Search by name or email',
      roleFilterLabel: 'Filter by Role',
      roleFilterPlaceholder: 'All Roles',
    },
    dialogs: {
      addUser: 'Add User',
      editFots: 'FOT Assignment',
    },
    errors: {
      loadFailed: 'Failed to load users. Please try again.',
    },
  },
  provisionUser: {
    labels: {
      searchUser: 'Search',
      searchPlaceholder: 'Type a user name or email (min. 3 chars)...',
      detectedRole: 'Detected Role',
      allFotsForWork: 'All FOTs for Work',
      fotWork: 'FOTs for Work',
      allFotsForNotifications: 'All FOTs for Notifications',
      fotNotifications: 'FOTs for Notifications',
      fotPlaceholder: 'Select FOTs...',
      alreadyProvisioned: 'Already provisioned',
    },
    errors: {
      noRole:
        'This user has no Centaur role assigned. Resolve this in Azure Portal before provisioning.',
      multipleRoles:
        'This user has multiple Centaur roles assigned. Resolve this in Azure Portal before provisioning.',
      alreadyProvisioned:
        'This user is already provisioned and active. To change their FOTs, use the Edit action in the user list.',
      searchFailed: 'Failed to search users. Please try again.',
      loadFotsFailed: 'Failed to load FOTs. Please try again.',
      provisionFailed: 'Failed to provision user. Please try again.',
    },
    messages: {
      provisioned: 'User provisioned successfully.',
    },
  },
  editUserFots: {
    labels: {
      allFotsForWork: 'All FOTs for Work',
      fotWork: 'FOTs for Work',
      allFotsForNotifications: 'All FOTs for Notifications',
      fotNotifications: 'FOTs for Notifications',
      fotPlaceholder: 'Select FOTs...',
    },
    errors: {
      loadFotsFailed: 'Failed to load FOTs. Please try again.',
      saveFailed: 'Failed to update FOT assignments. Please try again.',
    },
    messages: {
      saved: 'FOT assignments updated successfully.',
    },
  },
  notificationPreferencesList: {
    title: 'Email Preference Catalog',
    actions: {
      addNew: 'add preference',
      edit: 'Edit',
      activate: 'Activate',
      deactivate: 'Deactivate',
    },
    columns: {
      key: 'Key',
      displayName: 'Display Name',
      roles: 'Roles',
      status: 'Status',
      actions: 'Actions',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    dialogs: {
      addNew: 'Add Email Preference',
      edit: 'Edit Email Preference',
    },
    errors: {
      loadFailed: 'Failed to load email preferences. Please try again.',
      activateFailed: 'Failed to activate email preference. Please try again.',
      deactivateFailed:
        'Failed to deactivate email preference. Please try again.',
    },
    messages: {
      activated: 'Email preference activated.',
      deactivated: 'Email preference deactivated.',
    },
  },
  notificationPreferenceEdit: {
    labels: {
      key: 'Key',
      displayName: 'Display Name',
      roles: 'Roles',
      rolesPlaceholder: 'Select roles...',
      isActive: 'Active',
    },
    errors: {
      saveFailed: 'Failed to save email preference. Please try again.',
    },
    messages: {
      created: 'Email preference created successfully.',
      updated: 'Email preference updated successfully.',
    },
  },
  adminCaseTypePermissions: {
    title: 'Case Type Permissions',
    actions: {
      addPermission: 'Add Permission',
      reloadCache: 'Reload Cache',
      edit: 'Edit',
      delete: 'Delete',
    },
    columns: {
      caseType: 'Case Type',
      roleName: 'Role',
      assetContext: 'Asset Context',
      actions: 'Actions',
    },
    form: {
      caseTypePlaceholder: 'e.g. RL',
      roleNamePlaceholder: 'e.g. Centaur.FSM',
      assetContextPlaceholder: 'Well or Facility',
    },
    messages: {
      cacheReloaded: 'Cache reloaded successfully.',
      created: 'Permission created.',
      updated: 'Permission updated.',
      deleted: 'Permission deleted.',
    },
    errors: {
      loadFailed: 'Failed to load permissions. Please try again.',
      saveFailed: 'Failed to save permission. Please try again.',
      deleteFailed: 'Failed to delete permission. Please try again.',
      reloadFailed: 'Failed to reload cache. Please try again.',
    },
  },
  changeAccess: {
    title: 'Change Access',
    badge: 'NEW',
    stages: {
      requestChange: 'REQUEST CHANGE',
      completion: 'COMPLETION',
    },
    description: {
      title: 'update user',
      subtitle: 'Select a user & adjust their access',
    },
    search: {
      label: 'Search by CAI or Email',
      scopeExternal: 'outside MCBU',
      scopeInternal: 'within MCBU',
      typeExternal: 'External',
      typeInternal: 'Internal',
    },
    userInfo: {
      cai: 'CAI',
      name: 'Name',
      email: 'Email',
      status: 'Status',
      lastLogin: 'Last Login',
    },
    roles: {
      sectionTitle: 'User Roles',
      addButton: 'Add Role',
      formTitle: 'Add New Role',
      placeholder: 'Select Role...',
      columnName: 'Role Name',
      columnAction: 'Action',
      deleteTitle: 'Delete Role',
      empty: 'No roles assigned',
    },
    workAssignments: {
      sectionTitle: 'Work Assignments',
      addButton: 'Add Assignment',
      formTitle: 'Add New Work Assignment',
      placeholder: 'Select Workflow...',
      columnWorkflowType: 'Workflow Type',
      columnAssignedDate: 'Assigned Date',
      columnAction: 'Action',
      deleteTitle: 'Delete Assignment',
      empty: 'No work assignments',
    },
    fots: {
      sectionTitle: 'FOT Assignments',
      emailGroupTitle: 'FOTs for Receiving Emails',
      workGroupTitle: 'FOTs for Work Assignment',
      activeFots: 'Active FOTs',
      historicalFots: 'Historical FOTs',
    },
    completion: {
      title: 'Request Submitted',
      message: 'User access change request has been submitted for approval.',
    },
    actions: {
      submitRequest: 'Submit Request',
      backToOptions: 'Back to Options',
      backToOptionsTitle: 'Back to Options',
    },
  },
  rlWorkflow: {
    caseList: {
      title: 'RL Workflow Cases',
      empty: 'No RL cases found.',
      loadError: 'Unable to load cases. Please refresh the page.',
      columns: {
        caseNumber: 'Case Number',
        wellName: 'Well Name',
        fot: 'FOT',
        stage: 'Stage',
        statusWork: 'Status',
        jobType: 'Job Type',
        actions: 'Actions',
      },
    },
    planning: {
      title: 'Job Plan',
      notFound: 'Case not found.',
      placeholder: 'PE Job Plan form will be implemented in Phase 2.',
      saved: 'Job plan saved.',
      submitted: 'Case submitted to Pre-Scheduling.',
      jobPlanPacketNote: 'A Job Plan Packet attachment must be uploaded before submitting (FR-004, FR-045). Use the attachments panel above to attach the file.',
      sections: {
        wellInfo: 'Well Information',
        wellTests: 'Well Tests',
        jobInfo: 'Job Information',
        jobPlanPacket: 'Job Plan Packet',
      },
      fields: {
        wellName: 'Well Name',
        api14: 'API 14',
        liftMethod: 'Lift Method',
        field: 'Field',
        state: 'State',
        area: 'Area',
        fot: 'FOT',
        plantCode: 'Plant Code',
        companyCode: 'Company Code',
        costCenter: 'Cost Center',
        latitude: 'Latitude',
        longitude: 'Longitude',
        failureDate: 'Failure Date',
        localReferenceNumber: 'Local Reference Number',
        wbs: 'WBS',
        wellTest1: 'Well Test 1 (BOED)',
        wellTest2: 'Well Test 2 (BOED)',
        wellTest3: 'Well Test 3 (BOED)',
        avgBOED: 'Avg BOED',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        isSimops: 'SIMOPS',
        comments: 'Comments',
      },
      placeholders: {
        select: '-Select-',
      },
      actions: {
        submit: 'Submit to Pre-Scheduling',
      },
      validation: {
        jobTypeRequired: 'Job Type is required before submitting.',
        jobReasonRequired: 'Job Reason is required before submitting.',
      },
      readOnlyNotice: 'This case has been submitted and is no longer editable in the Planning stage.',
    },
    preScheduling: {
      title: 'Pre-Scheduling',
      notFound: 'Case not found.',
      placeholder: 'Pre-Scheduling form will be implemented in Phase 2.',
      reviewSaved: 'Review saved.',
      wellviewLinked: 'Wellview job linked.',
      scheduled: 'Case scheduled. Advancing to Job Execution.',
      sentBack: 'Case sent back to Planning.',
      wellviewStubNotice: 'Note: Wellview, MWL, and GIS integrations are stubs in this release. Wellview job ID must be entered manually.',
      gisStubNotice: 'Note: GIS/environmental indicators (Prairie Chicken Polygon, Airport Polygon) are not auto-populated in this release. Enter values manually if applicable.',
      wellviewCurrentlyLinked: 'Currently linked Wellview Job ID:',
      sections: {
        wlmReview: 'WLM Engineer Review',
        wellviewLink: 'Wellview Job Link',
        schedulerValues: 'Scheduler Values',
      },
      fields: {
        projectedJobDays: 'Projected Job Days',
        isWellRigReady: 'Well / Rig Ready',
        preScheduleStatus: 'Pre-Schedule Status',
        plannedCost: 'Planned Cost',
        preScheduleComment: 'Pre-Schedule Comment',
        wellviewJobEntered: 'Job Entered in Wellview',
        wellviewJobId: 'Wellview Job ID',
        wellviewJobIdPlaceholder: 'Enter Wellview Job ID',
        rigId: 'Rig',
        queueOrder: 'Queue Order',
        workflowDetermination: 'Workflow Determination',
        dpiRatio: 'DPI Ratio',
        bblsperM: 'BBLS/Month',
        production: 'Production',
        gkScore: 'GK Score',
        rigUp: 'Rig Up Date',
        projRigDown: 'Proj. Rig Down Date',
        projectedJobDaysScheduler: 'Projected Job Days',
        electricalVariance: 'Electrical Variance',
        api12: 'API 12',
        wellheadHeight: 'Wellhead Height (inches)',
        isSimops: 'SIMOPS',
        prairieChicken: 'Prairie Chicken / Dune Lizard Polygon',
        airportPolygon: 'Is Well On Airport Polygon?',
        hasPriorityIssue: 'Priority Issue',
        priorityDate: 'Priority Date',
        priorityWellComments: 'Priority Well Comments',
      },
      placeholders: {
        select: '-Select-',
        selectRig: '-Select Rig-',
      },
      actions: {
        saveReview: 'Save Review',
        linkWellview: 'Link Wellview Job',
        relinkWellview: 'Re-link Wellview Job',
        schedule: 'Schedule (Move to Execution)',
        sendBack: 'Send Back to Planning',
      },
      noRoleNotice: 'Your current role does not have edit access to any Pre-Scheduling sections. Contact your administrator if you need access.',
    },
    execution: {
      title: 'Job Execution',
      notFound: 'Case not found.',
      placeholder: 'Job Execution view will be implemented in Phase 3.',
      staleWarning: 'Wellview data may be out of date. Click Refresh Rig Report to update.',
      wellviewStubNotice: 'Note: Wellview integration is a stub in this release. Data shown is from the last stored snapshot.',
      wellviewRefreshed: 'Wellview data refreshed.',
      complianceSaved: 'Compliance confirmations saved.',
      finalReportGenerated: 'Final Report generated successfully.',
      finalReportError: 'Final Report generation failed. Please try again.',
      attachmentUploaded: 'File uploaded successfully.',
      noDailyReports: 'No daily reports available. Daily report data is populated via the Wellview integration.',
      noHourlyRemarks: 'No hourly remarks for this day.',
      autoProgressionNotice: 'Auto-progression to Job Close Out will occur automatically when all 6 completion conditions are met (FR-040–FR-041). Check "Disable Auto Progression" to hold in Job Execution.',
      lastSynced: 'Last synced:',
      readOnlyNotice: 'You are viewing this page in read-only mode. Only WSM role can record compliance confirmations.',
      sections: {
        wellviewSnapshot: 'Wellview Execution Data',
        rigReport: 'Rig Report',
        hourlyRemarks: 'Hourly Remarks',
        artifactStatus: 'Artifacts',
        compliance: 'Compliance Confirmations',
      },
      fields: {
        wellviewJobId: 'Wellview Job ID',
        rigUpDate: 'Rig Up Date',
        jobEnd: 'Job End',
        costToDate: 'Cost to Date ($)',
        totalHours: 'Total Hours',
        differenceGross: 'Difference Gross',
        reportDate: 'Date',
        wsmName: 'WSM',
        dailyCost: 'Daily Cost ($)',
        totalHoursWorked: 'Hours Worked',
        activityStart: 'Start',
        activityEnd: 'End',
        duration: 'Duration (hrs)',
        comments: 'Comments',
        disableAutoProgression: 'Disable Auto Progression (FR-040)',
        confirmElectricalVariance: 'Confirm Electrical Variance (FR-053)',
        confirmSimops: 'Confirm SIMOPS (FR-054)',
        wellviewWellboreUpdated: 'Wellview Wellbore Updated (FR-055)',
        rigDownDateInWellview: 'Rig Down Date in Wellview (FR-056)',
        jobClosed: 'Job Closed in Wellview (FR-058)',
        userIDOverride: 'UserID Override (FR-030)',
        userIDOverridePlaceholder: 'Enter UserID override if applicable',
      },
      artifacts: {
        jobPlanPacket: 'Job Plan Packet',
        finalReport: 'Final Report (PDF)',
        conservationStipulations: 'Conservation Stipulations (PDF)',
        supportingDocs: 'Supporting Pics / Reports',
      },
      actions: {
        refreshWellview: 'Refresh Rig Report',
        generateReport: 'Generate Final Report',
        download: 'Download',
        uploadFile: 'Upload File',
        saveCompliance: 'Save Confirmations',
      },
    },
    closeOut: {
      title: 'Job Close Out',
      notFound: 'Case not found.',
      placeholder: 'Job Close Out form will be implemented in Phase 4.',
      saved: 'Close Out data saved.',
      completed: 'Case completed. Resolved as Completed.',
      completeRequiresValidation: 'Wellview Wellbore must be validated before completing (BRU-032).',
      wellviewValidationNote: 'The Wellview Wellbore Validated checkbox is required before completing the case (BRU-032).',
      readOnlyNotice: 'You are viewing this page in read-only mode. Only ALS role can save and complete the Close Out.',
      sections: {
        wellInfo: 'ALS Well Information',
        failureDescription: 'Failure Description',
        failureAnalysis: 'Failure Analysis',
        completion: 'Completion',
      },
      fields: {
        wellName: 'Well Name',
        api14: 'API 14',
        fot: 'FOT',
        area: 'Area',
        costCenter: 'Cost Center',
        state: 'State',
        plantCode: 'Plant Code',
        companyCode: 'Company Code',
        latitude: 'Latitude',
        longitude: 'Longitude',
        localReferenceNumber: 'Local Reference Number',
        failureDate: 'Failure Date',
        oil_BOPD: 'Oil (BOPD)',
        water_BWPD: 'Water (BWPD)',
        gas_MCFPD: 'Gas (MCFPD)',
        failedComponentGroup: 'Failed Component Group',
        failedComponentType: 'Failed Component Type',
        failureLocation: 'Failure Location',
        failureDepth: 'Failure Depth',
        componentDisposition: 'Component Disposition',
        failureRemarks: 'Failure Remarks',
        failureAnalysisCompletionDate: 'Failure Analysis Completion Date',
        primaryFailureClass: 'Primary Failure Class',
        analysisRemarks: 'Analysis Remarks',
        primaryFailureCause: 'Primary Failure Cause',
        rootFailureCause: 'Root Failure Cause',
        failureSolution: 'Failure Solution',
        failureObservations: 'Failure Observations',
        preventativeMaintenance: 'Preventative Maintenance',
        actualJobCost: 'Actual Job Cost',
        personPerformingTask: 'Person Performing Task',
        isFailure: 'Failure',
        responsiblePerson: 'Responsible Person',
        jobType: 'Job Type',
        jobReason: 'Job Reason',
        wellviewWellboreValidated: 'Wellview Wellbore Validated (BRU-032)',
      },
      placeholders: {
        select: '-Select-',
      },
      actions: {
        complete: 'Complete Case',
      },
    },
    cancel: {
      title: 'Cancel Case',
      cancelCase: 'Cancel Case',
      cancelled: 'Case cancelled successfully.',
      fields: {
        reason: 'Cancellation Reason',
        reasonPlaceholder: '-Select reason-',
        details: 'Details',
        detailsPlaceholder: 'Optional: provide additional context for this cancellation',
      },
      reasons: {
        duplicateOrHumanError: 'Duplicate or Human Error',
        planToPA: 'Plan to PA',
        wellDivested: 'Well Divested',
        wellRecovered: 'Well Recovered',
      },
      actions: {
        confirm: 'Confirm Cancellation',
      },
    },
    admin: {
      rigs: {
        title: 'Rig Management',
        addRig: 'Add Rig',
        empty: 'No rigs found.',
        created: 'Rig created successfully.',
        updated: 'Rig updated successfully.',
        deleted: 'Rig deleted successfully.',
        columns: {
          name: 'Rig Name',
          rigType: 'Rig Type',
          available: 'Available',
        },
        fields: {
          name: 'Rig Name',
          namePlaceholder: 'Enter rig name',
          rigType: 'Rig Type',
          rigTypePlaceholder: 'Enter rig type (e.g. Slickline, Coil Tubing)',
          isAvailable: 'Available for assignment',
        },
        dialogs: {
          addRig: 'Add Rig',
          editRig: 'Edit Rig',
        },
      },
      lookups: {
        title: 'Lookup Management',
        selectField: 'Select field key',
        selectPrompt: 'Select a field key to view its options.',
        empty: 'No options found for the selected field.',
        addOption: 'Add Option',
        created: 'Lookup option created.',
        updated: 'Lookup option updated.',
        deleted: 'Lookup option deleted.',
        columns: {
          value: 'Value',
          parentField: 'Parent Field',
          parentValue: 'Parent Value',
          sortOrder: 'Sort Order',
        },
        fields: {
          value: 'Value',
          valuePlaceholder: 'Enter option value',
          parentFieldKey: 'Parent Field Key',
          parentFieldKeyPlaceholder: 'e.g. JobType (leave blank if none)',
          parentValue: 'Parent Value',
          parentValuePlaceholder: 'e.g. Pump Change Out (leave blank if none)',
          sortOrder: 'Sort Order',
        },
        dialogs: {
          addOption: 'Add Lookup Option',
          editOption: 'Edit Lookup Option',
        },
      },
    },
  },
  fdWorkflow: {
    caseForm: {
      title: 'Facility Decommission Case',
      notFound: 'Case not found.',
    },
    stages: {
      projectDataEntry:        'Project Data Entry',
      environmentalLandReview: 'Environmental & Land Review',
      siteScoping:             'Site Scoping',
      scopingReview:           'Scoping Review',
      afeReview:               'AFE Review',
      eamPermitting:           'Workorders & Permitting',
      digPlanning:             'Dig Planning',
      preScheduling:           'Pre Scheduling',
      activeScheduling:        'Active Scheduling',
      jobCloseOut:             'Job Close Out',
      resolvedCompleted:       'Resolved Completed',
    },
    sections: {
      facilityInfo: 'Facility Information',
      equipmentList: 'Equipment List',
      wellsList: 'Wells List',
      contactList: 'Contact List',
      attachFiles: 'Attach Files',
    },
    fields: {
      facilityName:          'Facility Name',
      chevno:                'Chevno',
      facilityId:            'Facility ID',
      fot:                   'FOT',
      state:                 'State',
      section:               'Section',
      township:              'Township',
      range:                 'Range',
      survey:                'Survey',
      groundElevation:       'Ground Elevation',
      latitude:              'Latitude',
      longitude:             'Longitude',
      landOwnership:         'Land Ownership',
      reasonForDecommission: 'Reason for Decommission',
      directionsToFacility:  'Directions to Facility',
    },
    landOwnership: {
      nmslo:        'NMSLO',
      blm:          'BLM',
      newMexicoFee: 'New Mexico Fee',
      texasFee:     'Texas Fee',
      other:        'Other',
    },
    actions: {
      attachments:  'Attachments',
      contacts:     'Contacts',
      pulse:        'Pulse',
      close:        'Close',
      relatedCases: 'Related cases',
      cancelJob:    'Cancel Case',
      submit:       'Submit',
    },
    equipmentList: {
      addRow:    'Add row',
      removeRow: 'Remove row',
      noItems:   'No items',
      columns: {
        description: 'Description',
        count:       'Count',
        reuse:       'Reuse?',
        comments:    'Comments',
      },
    },
    wellsList: {
      addRow:            'Add row',
      removeRow:         'Remove row',
      noItems:           'No items',
      searchPlaceholder: 'Type to search by API14 or Well Name...',
      columns: {
        wellName: 'Well Name',
        api14:    'API 14',
        fot:      'FOT',
        area:     'Area',
      },
    },
    contactList: {
      addRow:    'Add row',
      removeRow: 'Remove row',
      noItems:   'No items',
      columns: {
        name:  'Name',
        role:  'Role',
        phone: 'Phone number',
        email: 'Email',
      },
    },
    messages: {
      savedSuccess:                  'Create Dig Plan saved successfully.',
      preSchedulingSubmittedSuccess:    'Pre Scheduling submitted successfully.',
      activeSchedulingSavedSuccess:     'Active Scheduling saved successfully.',
      activeSchedulingSubmittedSuccess: 'Active Scheduling submitted successfully.',
      jobCloseOutSavedSuccess:          'Job Close Out saved successfully.',
      saveError:                     'Failed to save. Please try again.',
      submittedSuccess:              'Project data entry submitted successfully.',
      submitError:                   'Failed to submit. Please check the form and try again.',
      siteScopingSavedSuccess:             'Site Scoping saved successfully.',
      siteScopingSubmittedSuccess:         'Site Scoping submitted successfully.',
      scopingReviewSavedSuccess:           'Scoping Review saved successfully.',
      scopingReviewSubmittedSuccess:       'Scoping Review submitted successfully.',
      afeReviewSavedSuccess:               'AFE Review saved successfully.',
      afeReviewSubmittedSuccess:           'AFE Review submitted successfully.',
      digPlanApprovalSavedSuccess:         'Dig Plan Approval saved successfully.',
      digPlanApprovalSubmittedSuccess:      'Dig Plan Approval submitted successfully.',
      digPlanExecutionSavedSuccess:         'Dig Plan Execution saved successfully.',
      digPlanExecutionSubmittedSuccess:     'Dig Plan Execution submitted successfully.',
      envReviewSavedSuccess:         'Environmental Review saved successfully.',
      envReviewSubmittedSuccess:     'Environmental Review submitted successfully.',
      landReviewSavedSuccess:        'Land Review saved successfully.',
      landReviewSubmittedSuccess:    'Land Review submitted successfully.',
      eamReviewSubmitted:            'Workorders Review submitted successfully.',
      projectPermittingSubmitted:    'Project Permitting submitted successfully.',
      eamPermittingSavedSuccess:     'Workorders / Permitting saved successfully.',
      preSchedulingSavedSuccess:     'Pre-Scheduling saved successfully.',
      projectDataEntrySavedSuccess:  'Project Data Entry saved successfully.',
      eamPermittingBothPending:      'Please submit both Workorders Review and Project Permitting tabs to complete this stage.',
      caseCompletedSuccess:          'Facility Decommission case has been completed successfully.',
      recFacilityCaseCreated:         'Facility Reclamation case {{caseNumber}} has been created successfully.',
      recFacilityCaseCreateFailed:    'Job Close Out submitted successfully, but the Facility Reclamation case could not be created. Please create it manually.',
      fdCaseCompleteThankYou:         'Thank you. The Facility Decommission case is complete.',
    },
    pdeAttachFiles: {
      kmzLabel:       'Attach KMZ',
      kmzAttached:    'KMZ is attached.',
      kmzNotAttached: 'KMZ is not attached.',
    },
    validation: {
      title:          'Complete Required Fields',
      description:    'Enter the required fields below before submitting.',
      duplicateWells:   'Duplicate wells in Wells List',
      manualWellEntry:  'All wells must be selected from the search results',
      emptyWellRows:     'Wells List contains empty rows',
      emptyEquipmentRows: 'Equipment List contains empty rows',
      emptyContactRows:   'Contact List contains empty rows',
      manualContactEntry: 'All contacts must be selected from the search results',
      duplicateContacts:  'Duplicate contacts in Contact List',
      manualPocEntry:     'Point of Contact must be selected from the search results',
    },
    envReview: {
      sections: {
        environmentalInfo: 'Environmental Information',
      },
      fields: {
        openRelease:          'Is there an open release/spill at location?',
        releaseSpillDetails:  'Release/Spill Details',
        openRemediation:      'Is there an open remediation project at location?',
        remediationProjectDetails: 'Remediation Project Details',
        esaChecksCompleted:   'Have ESA Checks been Completed?',
        pointOfContact:       'Point of Contact',
        environmentalDetails: 'Environmental Details',
      },
      attachFiles: {
        title:        'Attach Files',
        attachLabel:  'Attach Regulatory Paperwork',
        attached:     'Regulatory Paperwork is attached.',
        notAttached:  'Regulatory Paperwork is not attached.',
        dialogHeader: 'Attach Regulatory Paperwork',
      },
    },
    landReview: {
      sections: {
        landInfo: 'Land Information',
      },
      fields: {
        facilityId:                        'Facility ID',
        wellIsLwolLwou:                    'Well is a LWOL/LWOU',
        copCriticalDate:                   'COP Critical Date',
        surfaceOwnerNotificationRequired:  'Surface Owner Notification Required?',
        workingInterestOwnerApproval:      'Is working interest owner approval required?',
        workingInterest:                   'Working Interest (%)',
        netRevenueInterest:                'Net Revenue Interest (%)',
        additionalParties:                 'Additional Parties',
        landComment:                       'Land Comment',
      },
    },
    scopingReview: {
      sections: {
        scopeReview: 'Scope Review',
      },
      actions: {
        approve: 'Approve',
        recycle: 'Recycle',
      },
      instruction1: 'Review site scoping & determine approval status.',
      instruction2: 'You may edit site scoping details regardless if you approve or reject.',
      rejectedBanner:    'Site Scoping was last rejected on',
      commentsRequired:  'Comments are required when rejecting.',
      fields: {
        scopeReviewApproval: 'Scope Review Approval',
        scopeReviewComments: 'Scope Review Comments',
      },
    },
    afeReview: {
      sections: {
        afe:         'AFE',
        uploadFiles: 'Upload Files',
      },
      messages: {
        aesSumError:  'AES/AEF estimates should total the High-Level Estimate.',
        afeLinkError: 'AFE Link must be a valid URL (http, https, or ftp) with a chevron.com domain.',
      },
      uploadFiles: {
        approvedWbsLabel:       'Attach Approved WBS',
        approvedWbsAttached:    'Approved WBS is attached.',
        approvedWbsNotAttached: 'Approved WBS is not attached.',
      },
      fields: {
        highLevelEstimate: 'High Level Estimate',
        aesEstimate:       'AES Cost Estimate',
        aefEstimate:       'AEF Cost Estimate',
        approvedAes:       'Approved AES',
        approvedAef:       'Approved AEF',
        companyCode:       'Company Code',
        afeLink:           'AFE Link',
      },
      wbs: {
        addRow:            'Add WBS row',
        noItems:           'No WBS entries.',
        wbsNumber:         'WBS #',
        percentage:        '%',
        comments:          'WBS Comments',
        incompleteMessage: 'WBS is incomplete and requires details before proceeding.',
      },
    },
    eamPermitting: {
      sections: {
        eam: 'Workorders',
      },
      fields: {
        eamWorkOrdersCompleted: 'Work Orders Completed?',
      },
    },
    projectPermitting: {
      sections: {
        notifyAgencies: 'Notify Agencies',
        attachFiles:    'Attach Files',
      },
      notifyAgencies: {
        instruction: 'Select if Agency Notification(s) are required. If required, agency notification(s) must be attached.',
        agenciesNeedNotification: 'Agencies Need Notification(s)?',
      },
      attachFiles: {
        noiSundryLabel:                   'Attach NOI Sundry',
        noiSundryAttached:                'NOI Sundry is attached.',
        noiSundryNotAttached:             'NOI Sundry is not attached.',
        agencyNotificationLabel:          'Attach Agency Notification(s)',
        agencyNotificationAttached:       'Agency Notification is attached.',
        agencyNotificationNotAttached:    'Agency Notification is not attached.',
      },
    },
    digPlan: {
      sections: {
        createDigPlan:    'Create Dig Plan',
        businessPartners: 'Business Partners',
      },
      createDigPlan: {
        instruction:        'Please create & upload a Dig Plan. Then progress to the FSM Superintendent for approval.',
        digPlanLabel:       'Attach Dig Plan',
        digPlanAttached:    'Dig Plan is attached.',
        digPlanNotAttached: 'Dig Plan is not attached.',
        rejectedBy:         'Dig Plan was rejected by',
        rejectedByFallback: 'FSM Superintendent',
        rejectedOn:         'on',
      },
      businessPartners: {
        addRow:       'Add Business Partner row',
        noItems:      'No items',
        emailColumn:  'Business Partner Email',
        invalidEmail: 'Business Partner Email (invalid format)',
      },
      wellWork: {
        section:        'Well Work',
        caseId:         'Case ID',
        status:         'Status',
        createDateTime: 'Create DateTime',
        noItems:        'No Items',
      },
      digPlanApproval: {
        cardTitle:                'Dig Plan Approval',
        viewDigPlan:             'View Dig Plan',
        approvalSection:         'Determine Approval Status',
        statusLabel:             'Dig Plan Approval Status',
        commentsLabel:           'Approval Comments',
        rejectionCommentsLabel:  'Rejection Comments',
        rejectionCommentsRequired: 'Rejection Comments is required.',
        approved:         'Approved',
        rejected:         'Rejected',
        pendingReview:    'Pending Review',
        submittedSuccess: 'Dig Plan submitted for approval.',
        approvalSuccess:  'Dig Plan approval submitted successfully.',
        statusRequired:   'Please select an approval status.',
      },
      digPlanExecution: {
        cardTitle:           'Dig Plan Execution',
        instruction:         'The Dig Plan has been approved. Please begin facility prep execution now and submit to the schedule once it is completed.',
        digPlanCompleted:    'Dig Plan Completed?',
        viewDigPlan:         'View Dig Plan',
        approvalSection:     'Approval Comments',
        approverComments:    'Dig Plan Approver Comments',
        approvedSuccess:     'Dig Plan approved successfully.',
        rejectedMessage:     'Dig Plan rejected. Please revise and resubmit.',
        pendingMessage:      'Dig Plan is pending review.',
        executionSuccess:    'Dig Plan execution submitted successfully.',
        completionRequired:  'Please check "Dig Plan Completed" before submitting.',
      },
    },
    siteScoping: {
      sections: {
        samplingDetails:      'Sampling Details',
        environmentalImpacts: 'Environmental Impacts',
        costEstimate:         'Cost Estimate',
        equipmentList:        'Equipment List',
        contactList:           'Contact List',
        attachFiles:           'Attach Files',
      },
      fields: {
        samplingDetails:      'Sampling Details',
        environmentalImpacts: 'Environmental Impacts',
      },
      attachFiles: {
        attachLabel:          'Attach Sampling Details',
        attached:             'Sampling Details is attached.',
        notAttached:          'Sampling Details is not attached.',
        dialogHeader:         'Attach Sampling Details',
        samplingLabel:        'Attach Sampling Details',
        samplingAttached:     'Sampling Details is attached.',
        samplingNotAttached:  'Sampling Details is not attached.',
        beforePhotoLabel:     'Attach "Before" Decommission Photo(s)',
        beforePhotoAttached:  '"Before" Photo is attached.',
        beforePhotoNotAttached: '"Before" Photo is not attached.',
      },
      costEstimate: {
        instruction:   'Complete & attach the high level cost estimate.',
        subtotal:      'Subtotal ($)',
        contingency:   'Contingency ($)',
        gnaPercent:    'G&A (%)',
        gnaCost:       'G&A Cost ($)',
        totalCost:     'Total Cost ($)',
        gnaLastPulled: 'G&A Percent was last pulled on',
        attachLabel:   'Attach Cost Estimate',
        attached:      'Cost Estimate is attached.',
        notAttached:   'Cost Estimate is not attached.',
        dialogHeader:  'Attach Cost Estimate',
        gnaCostExceedsLimit:   'G&A Cost exceeds the maximum allowed value',
        totalCostExceedsLimit: 'Total Cost exceeds the maximum allowed value',
      },
    },
    fdPreScheduling: {
      sections: {
        schedulerValues: 'Scheduler Values',
        selectCrew:      'Select Crew',
        wellWork:        'Well Work',
      },
      schedulerValues: {
        facilityId:       'Facility ID',
        projectedJobDays: 'Projected Job (Days)',
        setDatesManually: 'Set dates manually?',
        startDate:        'Start Date',
        projEndDate:      'Proj. End Date',
        projEndDateAfterStartDate: 'Proj. End Date must be at least 1 day after Start Date',
      },
      selectCrew: {
        crewLabel:       'Schedule Crew',
        placeholder:     '-select-',
        noCrewAvailable: 'No crews available.',
        queueOrder: {
          cardTitle:        'Select Queue Order',
          assetName:        'Asset Name',
          caseId:           'Case ID',
          queueOrder:       'Queue Order',
          area:             'Area',
          startDate:        'Start Date',
          projEndDate:      'Proj. End Date',
          projectedJobDays: 'Projected Job Days',
          deadlineDate:     'Deadline Date',
          dragRow:          'Drag to reorder',
        },
      },
    },
    fdActiveScheduling: {
      sections: {
        jobCompletion: 'Job Completion',
        wellWork:      'Well Work',
        attachFiles:   'Attach Files',
      },
      jobCompletion: {
        instruction:              'Please enter job completion date and identify if facility reclamation is required.',
        jobCompletionDate:        'Job Completion Date',
        needsFacilityReclamation: 'Needs Facility Reclamation?',
        reclamationComments:      'Reclamation/Close Out Comments',
        yes:                      'Yes',
        no:                       'No',
      },
      attachFiles: {
        closeOutLabel:           'Attach Close Out Document(s)',
        closeOutAttached:        'Close Out Document is attached.',
        closeOutNotAttached:     'Close Out Document is not attached.',
        inProgressLabel:         'Attach "In-Progress" Decommission Photo(s)',
        inProgressAttached:      '"In-Progress" Photo is attached.',
        inProgressNotAttached:   '"In-Progress" Photo is not attached.',
        afterLabel:              'Attach "After" Decommission Photo(s)',
        afterAttached:           '"After" Photo is attached.',
        afterNotAttached:        '"After" Photo is not attached.',
      },
    },
    fdJobCloseOut: {
      sections: {
        notifyAgencies:      'Notify Agencies',
        facilityReclamation: 'Facility Reclamation',
        wellWork:            'Well Work',
        attachFiles:         'Attach Files',
      },
      notifyAgencies: {
        instruction:           'Please indicate if agencies have been notified of completion (required for New Mexico facilities).',
        agenciesNotifiedLabel: 'Agencies Notified of Completion?',
      },
      facilityReclamation: {
        instruction:        'Please review the FSM\'s suggestion and determine if Facility Reclamation is required.',
        fsmSuggestionLabel: 'Facility Reclamation Needed? - FSM Suggestion',
        executeLabel:       'Execute Facility Reclamation?',
      },
    },
  },
  paCommon: {
    workflowLabel: 'Request Plug & Abandonment',
    cancelledBadge: 'Cancelled',
    actions: {
      cancelJob: 'Cancel Job',
    },
  },
  paRequest: {
    stages: {
      request: 'Request P&A',
      landReview: 'Land Review',
      surfaceCost: 'Surface Cost Estimate',
      siteReview: 'Survey/AFE',
      workOrder: 'Work Order Submission',
      centralMaintenance: 'Site Excavation',
      digPlan: 'Dig Plan',
      scheduling: 'Pre Schedule',
      execution: 'Job Execution',
      wellheadCutoff: 'Well Head Cut Off',
      closeOut: 'Job Close Out',
    },
    header: {
      titleSuffix: 'Request P&A',
      badge: 'PE Workbook',
      attachments: 'Attachments',
      auditLog: 'Audit Log',
      contacts: 'Contacts',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    sections: {
      wellInformation: 'Well Information',
      wellHeaderInformation: 'Well Header Information',
      wellPlan: 'Well Plan',
      formationTops: 'Formation Tops',
      tubularRods: 'Tubulars / Rods',
      wellHistory: 'Well History',
      contactList: 'Contact List',
      waterboardLetter: 'Waterboard Letter',
      peNotes: 'PE Notes',
      facility: 'Facility',
      footageCall: 'Footage Call (distance to section lines)',
      wellboreDiagram: 'Attach Files',
    },
    wellboreDiagram: {
      description: 'Attach the current wellbore diagram (Excel format) required for submission.',
      attachAction: 'Attach Current Wellbore Diagram',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      api10: 'API 10',
      api12: 'API 12',
      state: 'State',
      area: 'Area',
      fot: 'FOT',
      costCenter: 'Cost Center',
      companyCode: 'Company Code',
      latitude: 'Latitude',
      longitude: 'Longitude',
      localReferenceNumber: 'Local Reference Number',
      field: 'Field',
      spudDate: 'Spud Date',
      completionDate: 'Completion Date',
      shutInDate: 'Shut-In Date',
      operator: 'Operator',
      countyName: 'County Name',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      paPriorityLevel: 'P&A Priority Level',
      currentWellStatus: 'Current Well Status',
      isH2sOver100Ppm: 'H2S Concentration > 100 PPM?',
      isNormPresent: 'NORM Present in Area?',
      governingAuthority: 'Governing Authority',
      plannedWorkDescription: 'Planned Work Description',
      wellboreType: 'Wellbore Type',
      governorDistrictNumber: 'Governor District Number',
      county: 'County',
      landSection: 'Section',
      township: 'Township',
      range: 'Range',
      plannedStartDate: 'Planned Start Date',
      estimatedJobDays: 'Estimated Job Days',
      salvageZone: 'Salvage Zone',
      formationName: 'Formation Name',
      topDepth: 'Top Depth',
      tubularType: 'Type',
      outerDiameter: 'OD (in)',
      weight: 'Weight (lb/ft)',
      tubularTopDepth: 'Top Depth (ft)',
      bottomDepth: 'Bottom Depth (ft)',
      quantity: 'Quantity',
      grade: 'Grade',
      condition: 'Condition',
      eventDate: 'Date',
      eventText: 'Event',
      attachWellHistory: 'Attach Well History',
      contactName: 'Name',
      contactRole: 'Role',
      phoneNumber: 'Phone Number',
      email: 'Email',
      peNotes: 'PE Notes',
      peNotesCharsRemaining: 'characters remaining',
      hasFacilityAssociated: 'FD / Facility Associated?',
      facilityDecomTooltip: 'Check this box to create a Facility Decommission work record for this well.',
      facilityDescription: 'Facility Description / Chevno',
      facilityName: 'Facility Name',
      facilityId: 'Facility ID',
      chevno: 'Chevno',
      isWaterboardNotificationRequired: 'Waterboard Letter Request',
      survey: 'Survey',
      wbsNumber: 'WBS Number',
      groundElevation: 'Ground Elevation',
      kellyBushingElevation: 'Kelly Bushing Elevation',
      footageNorth: 'Footage North',
      footageSouth: 'Footage South',
      footageEast: 'Footage East',
      footageWest: 'Footage West',
      // §9.2.3.2 Well Plan
      objective: 'Objective',
      proposedZone: 'Proposed Zone',
      paTaDeadline: 'PA/TA Deadline',
      lastProductionDate: 'Last Production Date',
      lastProductionVolume: 'Last Production Volume',
      lastProductionPsi: 'Last Production PSI',
      currentPerforations: 'Current Perforations',
      reasonForPaTa: 'Reason For PA/TA',
      tubularRodsNotAttached: 'Tubulars and Rods (pdf) is not attached.',
      tubularRodsAttached: 'Tubulars and Rods (pdf) is attached.',
      wellHistoryNotAttached: 'Well History is not attached.',
      wellHistoryAttached: 'Well History is attached.',
      waterboardLetterNotAttached: 'Waterboard Letter is not attached.',
      waterboardLetterAttached: 'Waterboard Letter is attached.',
      wellboreDiagramNotAttached: 'Current Wellbore Diagram (excel) is not attached.',
      wellboreDiagramAttached: 'Current Wellbore Diagram (excel) is attached.',
      selectOption: '-select-',
    },
    actions: {
      cancel: 'Cancel',
      save: 'Save',
      submit: 'Submit',
      addRow: 'Add Row',
      removeRow: 'Remove',
      deleteRow: 'Delete row',
      attachTubularsRods: 'Attach Tubulars and Rods',
      attachWellHistory: 'Attach Well History',
      attachWaterboardLetter: 'Attach Waterboard Letter',
      requestWaterboardLetter: 'Request Waterboard Letter',
      requestFormationTops: 'Request Formation Tops',
    },
    validation: {
      paPriorityLevelRequired: 'P&A Priority Level is required.',
      currentWellStatusRequired: 'Current Well Status is required.',
      governingAuthorityRequired: 'Governing Authority is required.',
      h2sConcentrationRequired: 'H2S Concentration > 100 PPM is required.',
      normPresentRequired: 'NORM Present in Area is required.',
      formationTopsRequired: 'At least one Formation Tops row is required to submit.',
      wellboreDiagramRequired: 'A Wellbore Diagram (excel) is required to proceed.',
      wellHistoryAttachmentRequired: 'A well history attachment is required to proceed.',
      waterboardLetterRequired: 'Please attach the waterboard letter to proceed.',
      facilityNameRequired: 'Facility Name is required.',
      wellNameRequired: 'Well Name is required.',
      api14Required: 'API 14 is required.',
      api14Length: 'API 14 must be exactly 14 characters.',
      stateRequired: 'State is required.',
      areaRequired: 'Area is required.',
      fotRequired: 'FOT is required.',
      costCenterRequired: 'Cost Center is required.',
      latitudeRequired: 'Latitude is required.',
      longitudeRequired: 'Longitude is required.',
      companyCodeRequired: 'Company Code is required.',
      chevnoMaxLength: 'Chevno must be 14 characters or fewer.',
      completionDateFuture: 'Completion Date cannot be a future date.',
      shutInDateFuture: 'Shut-In Date cannot be a future date.',
      phoneInvalid: 'Please enter a valid phone number.',
      emailInvalid: 'Please enter a valid email address.',
    },
    waterboard: {
      description: 'Select below if a waterboard letter request should accompany this P&A submission.',
      buttonHelperText: 'Note: Waterboard Letter is not required for New Mexico wells.',
    },
    formationTopsEmail: {
      sectionTitle: 'Formation Tops Information Request',
      templateLabel: 'Email Template',
      templateName: 'PA - PE Formation Tops Information Request',
      toLabel: 'To',
      toValue: 'Geologist Distribution List',
      subjectLabel: 'Subject',
      ccLabel: 'Additional Recipients / cc',
      bodyLabel: 'Body',
      body: 'The Formation Tops data for the well referenced above has been submitted for your review. Please provide any relevant geological information for the plug and abandonment plan.',
      dismiss: 'Dismiss',
      loading: 'Loading email preview…',
      send: 'Send Request',
      sendSuccess: 'Formation Tops request email sent successfully.',
      loadError: 'Unable to load the email preview. Please dismiss and try again.',
      additionalRecipientsLabel: 'Additional Recipients',
      addRecipient: 'Add recipient',
      removeRecipient: 'Remove recipient',
      additionalNotesLabel: 'Additional Notes',
      additionalNotesPlaceholder: 'Enter any additional notes to include in the email…',
    },
    waterboardEmail: {
      sectionTitle: 'Waterboard Letter Request',
      toLabel: 'To',
      subjectLabel: 'Subject',
      bodyLabel: 'Body',
      dismiss: 'Dismiss',
      loading: 'Loading email preview…',
      send: 'Send Request',
      sendSuccess: 'Waterboard letter request email sent successfully.',
      loadError: 'Unable to load the email preview. Please dismiss and try again.',
      additionalRecipientsLabel: 'Additional Recipients',
      addRecipient: 'Add recipient',
      removeRecipient: 'Remove recipient',
      additionalNotesLabel: 'Additional Notes',
      additionalNotesPlaceholder: 'Enter any additional notes to include in the email…',
    },
    submitEmail: {
      sectionTitle: 'PE Workbook Submitted for Land Review',
      toLabel: 'To',
      subjectLabel: 'Subject',
      bodyLabel: 'Body',
      loading: 'Loading email preview…',
      send: 'Submit',
      sending: 'Sending email…',
      reviewHint: 'Review the email above, then click Submit again to send it and move this case to Land Review.',
      sendSuccess: 'Notification email sent successfully.',
      loadError: 'Unable to load the email preview.',
      skipToLandReview: 'Save',
      additionalRecipientsLabel: 'Additional Recipients',
      addRecipient: 'Add recipient',
      removeRecipient: 'Remove recipient',
      additionalNotesLabel: 'Additional Notes',
      additionalNotesPlaceholder: 'Enter any additional notes to include in the email…',
    },
    comments: {
      title: 'Comments',
      placeholder: 'Enter your comment…',
      save: 'Save',
      saveSuccess: 'Comment saved.',
      saveError: 'Failed to save comment.',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    tooltips: {
      requestFormationTops: 'Send email to request formation tops. Any contacts you have added to this job\'s contact list will be automatically appended to the recipients.',
      hasFacilityAssociated: 'Check this box to create a Facility Decommission work record for this well.',
    },
    formationTops: {
      requestedOn: 'Formation Tops last requested on',
    },
  },
  paLandReview: {
    header: {
      titleSuffix: 'Land Review',
      badge: 'Land Review',
      attachments: 'Attachments',
      auditLog: 'Audit Log',
      contacts: 'Contacts',
      comments: 'Comments',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    tabs: {
      wellInformation: 'Well Information',
      engineeringRequest: 'Engineering Request',
      landInformation: 'Land Information',
      landComments: 'Land Comments',
      ownership: 'Ownership',
      other: 'Other',
    },
    sections: {
      wellInformation: 'Well Information',
      engineeringRequest: 'Engineering Request',
      landInformation: 'Land Information',
      landComments: 'Land Comments',
      leaseDetails: 'Lease Details',
      property: 'Property - (Check all that are applicable)',
      forfeitureChevronInterest: 'Chevron Interest / Forfeiture Decision',
      forfeitureFollowUp: 'If Forfeiture results, Complete the following:',
      ownershipSettings: 'Ownership Settings',
      ownership: 'Ownership',
      operatorsAndWio: 'Operators and Working Interest Owners',
      operators: 'Operators',
      workingInterestOwners: 'Working Interest Owners',
      section: 'Section',
      easementWarning: 'Surface Easement may apply (Section: {{sectionNumber}}, QLS: {{qlsNumber}}). Verify with Land team.',
      ownershipLanguageSua: 'Ownership Language / SUA',
      landOwnership: 'Ownership Language',
      salvage: 'Salvage',
      reassignmentObligation: 'Reassignment Obligation',
      commentsAndTcLimitations: 'Comments / Title Clearance Limitations',
      conservation: 'Location and Conservation',
      conservationInfo: 'Conservation Information',
      surfaceOwner: 'Surface Owner',
      plat: 'Plat / Additional Comments',
      other: 'Other',
      notification: 'Notification',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      api10: 'API 10',
      state: 'State',
      fot: 'FOT',
      costCenter: 'Cost Center',
      companyCode: 'Company Code',
      lwol: 'Well is a LWOL / LWOU',
      isSurfaceOwnerNotificationRequired: 'Surface Owner Notification Required?',
      workingInterestPercent: 'Working Interest %',
      netRevenueInterestPercent: 'Net Revenue Interest %',
      nriReadOnly: 'Net Revenue Interest %',
      copCriticalDate: 'COP Critical Date',
      isLandNeedsReclaimed: 'Does the land need reclaimed?',
      landOwnershipType: 'Land Ownership',
      landComments: 'Land Comments',
      currentSituation: 'Current Situation',
      selectOption: '-select-',
      leaseWellName: 'Well Name',
      keyLandFileNo: 'Key Land File No.',
      otherLandFileNos: 'Other Land File Nos.',
      legalDescriptionOfLease: 'Legal Description of Lease',
      isChevronUsa: 'Chevron USA',
      is100PercentIntProperty: '100% Int Property',
      isPooledUnit: 'Pooled Unit',
      isChevronMidcontinent: 'Chevron Mid-continent',
      isMineralFee: 'Mineral Fee',
      isSurfaceFee: 'Surface Fee',
      isLegacyNoble: 'Legacy Noble',
      isWiUnit: 'WI Unit',
      isPartialIntProperty: 'Partial Interest Property',
      isSecRecUnit: 'Sec Rec Unit',
      gwi: 'GWI',
      forfeitureDecision: 'Will abandonment result in forfeiture?',
      forfeitureIfNotWhy: 'If Not, Why?',
      forfeitureLeaseAcquiredDate: 'Date lease(s) acquired',
      forfeitureLeaseholdCosts: 'Leasehold Costs',
      forfeitureGrossNetAcres: 'Gross/Net acres to be forfeited',
      forfeitureRightsDepthsForfeited: 'Rights and/or depths to be forfeited',
      forfeitureTimeToRemoveCasing: 'Time to remove casing/equipment',
      forfeitureDaysToRestoreFromCessation: 'Days operations is restored from cessation of production',
      forfeitureDaysToRestoreFromCessationTooltip: 'Production must be restored, rework operations or additional drilling must be commenced within the number of days entered from cessation of production in paying quantities.',
      forfeitureSubstancesCovered: 'Substances Covered',
      forfeitureSubstancesCoveredOtherDetail: 'Other Detail',
      forfeitureRightsDepthsRemaining: 'Rights and/or depths remaining',
      isNonOperatorApprovalRequired: 'Non-Operator Approval Required?',
      percentageVoteRequired: 'Percentage Vote Required',
      wioTimeToReply: 'Time to Reply',
      wioEntryMode: 'WIO Entry Mode',
      wioInstructionText: 'Please attach a list of WIO\'s or add them on the table below',
      wioModeAddManually: 'Add Manually',
      wioModeAttachFile: 'Attach File',
      participantId: 'Participant ID',
      participantName: 'Participant Name',
      typeOfInterest: 'Type of Interest',
      decimalInterest: 'Decimal Interest',
      isOperator: 'Operator',
      wioAttachAction: 'Attach Working Interest Owners',
      wioAttachFileNote: 'WIO document is not attached.',
      wioAttachFileNoteAttached: 'WIO document is attached.',
      sectionNumber: 'Section Number',
      qlsNumber: 'QLS Number',
      ownershipLanguage: 'Ownership Language',
      isSua: 'SUA?',
      suaProvisions: 'SUA Provisions',
      ownershipLanguageSelectNote: 'Select a Land Ownership Type to see Ownership Language or SUA fields.',
      isSalvageAtSalvageValue: 'Can any party take over the well at salvage value?',
      isSalvageChevron: 'Chevron',
      isSalvageNonOperator: 'Non-Operator',
      isSalvageLessorAssignor: 'Lessor/Assignor',
      isSalvageTractOwner: 'Tract Owner',
      isSalvageSurfaceOwner: 'Surface Owner',
      isSalvageOther: 'Other',
      salvagePartyNames: 'Party Name(s)',
      salvageAsTo: 'As to',
      salvageNameAddressNotes: 'Name, Address, Notes',
      isReassignmentObligation: 'Reassignment Obligation?',
      reassignmentToNameAddress: 'To (name and address)',
      reassignmentDaysToReply: 'Days Lessor/Assignor, etc. has to reply to reassignment offer',
      reassignmentDaysBeforeAbandonment: 'Days lease must be reassigned prior to abandonment',
      isReassignmentOffer: 'Offer',
      isReassignmentLease: 'Lease',
      isReassignmentTender: 'Tender',
      isReassignmentAssignment: 'Assignment',
      isReassignmentNotice: 'Notice',
      isReassignmentJoa: 'JOA',
      isReassignmentOther: 'Other',
      reassignmentOtherDetails: 'Other reassignment details',
      isAdverseLegalAction: 'Is there adverse legal action?',
      adverseLegalActionDetails: 'Adverse Legal Action Details',
      isTitleClearanceLimitations: 'Title Clearance has limitations?',
      titleClearanceLimitationsDetails: 'Title Clearance Limitations',
      isHabitatOfSandDunesLizardAndHornshellMussel: 'Is the location of the subject well within the habitat of the Sand Dunes Lizard and Texas Hornshell Mussel?',
      isConservationMeasuresRequired: 'Conservation Measures Required?',
      surfaceOwnerName: 'Surface Owner Name',
      surfaceOwnerAdditionalContact: 'Additional Contact',
      surfaceOwnerLegalDescription: 'Legal Description',
      isSurfaceOwnerAccommodations: 'Are there surface owner accommodations?',
      platDetails: 'Plat Details',
      otherNotes: 'Title Clearance Additional Comments',
      isGeneratingTitleClearance: 'Generate Title Clearance',
      titleClearanceApprovalStatus: 'Title Clearance Approval Status',
      operatorName: 'Operator Name',
      operatorType: 'Type',
      contactName: 'Contact Name',
      address: 'Address',
      phoneNumber: 'Phone Number',
      email: 'Email',
      ownerName: 'Owner Name',
      wioWorkingInterestPercent: 'Working Interest %',
      wioNetRevenueInterestPercent: 'Net Revenue Interest %',
      formationName: 'Formation Name',
      topDepth: 'Top Depth',
      plannedWorkDescription: 'Planned Work Description',
      paPriorityLevel: 'P&A Priority Level',
      currentWellStatus: 'Current Well Status',
      area: 'Area',
      field: 'Field',
      stateCode: 'State',
      countyName: 'County Name',
      chevno: 'Chevno',
      lastWellOnLease: 'Last Well on Lease',
      wbsNumber: 'WBS Number',
      localReferenceNumber: 'Local Reference Number',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      oil: 'Oil',
      water: 'Water',
      gas: 'Gas',
      latitude: 'Latitude',
      longitude: 'Longitude',
      isWioApprovalRequired: 'Is WIO Approval Required?',
      isAdditionalParties: 'Additional Parties?',
      objective: 'Objective',
      paTaDeadline: 'PA/TA Deadline',
      nmsloSectionBlankWarning: 'You must enter a Section Number in order to adjust the ownership language.',
      conservationInfoText: 'The surface location of the subject well is within enrolled acreage under that certain Certificate of Inclusion for Oil and Gas Operators in the Candidate Conservation Agreement with Assurances for the Texas Hornshell Mussel CI-HORN-03 dated 2/26/2018 (QLS 946196 and 959284). However, there are no stipulations under said Certificate of Inclusion for the type of work proposed in this title clearance.',
      conservationCourtesyText: 'As a courtesy, Chevron should notify CEHMM (575-885-3700) of our plans to P&A the subject well.',
      notificationGuidanceText: 'Please notify the following with the Title Clearance, Well file, and LIS files',
      notificationRecipientList: 'Technical Team Leader, Technical Team Engineer, Operations Supervisor, Facility Engineer, Surface Land Representative, Ownership Representative, Regulatory Analyst, Land Manager, Land Analyst',
      attachConservationMeasures: 'Attach Required Conservation Measures',
      conservationAttachmentStatus: 'Conservation Measures document is not attached.',
      conservationAttachmentStatusAttached: 'Conservation Measures document is attached.',
      attachPlat: 'Attach Plat',
      platAttachmentStatus: 'Plat is not attached.',
      platAttachmentStatusAttached: 'Plat is attached.',
    },
    actions: {
      save: 'Save',
      submit: 'Submit Land Review',
      submitLandReview: 'Submit',
      cancel: 'Cancel',
      addOperator: 'Add Operator',
      removeOperator: 'Remove',
      addWio: 'Add Row',
      removeWio: 'Remove',
      deleteRow: 'Delete row',
      reviewTitleClearance: 'Review Title Clearance',
      editLandDetails: 'Edit Land Details',
      cancelEditLandDetails: 'Cancel Edit',
      saveEditLandDetails: 'Save Land Details',
      editComments: 'Edit Comments',
    },
    validation: {
      landNeedsReclaimedRequired: 'Does the land need reclaimed? is required.',
      fdReclaimConflict: 'Cannot create a Rec case if a Facility Decom case was created during the creation stage.',
      landOwnershipTypeRequired: 'Land Ownership Type is required.',
      conservationMeasuresRequiredRequired: 'Conservation Measures Required? must be answered when generating a Title Clearance.',
      conservationAttachmentRequired: 'Conservation Measures document is required when Conservation Measures Required is Yes.',
    },
    tooltips: {
      isAdverseLegalAction: 'Indicates whether there is any adverse legal action that could affect the title clearance or land ownership.',
      isTitleClearanceLimitations: 'Indicates whether there are any limitations affecting the title clearance for this well.',
    },
    ownershipTypes: {
      nmslo: 'NMSLO',
      blm: 'BLM',
      newMexicoFee: 'New Mexico Fee',
      texasFee: 'Texas Fee',
      other: 'Other',
    },
    comments: {
      title: 'Comments',
      placeholder: 'Enter your comment…',
      save: 'Save',
      saveSuccess: 'Comment saved.',
      saveError: 'Failed to save comment.',
    },
  },
  paTitleClearanceModal: {
    title: 'Confirm Land Submission',
    infoLine1a: 'Title Clearance ',
    infoLine1Emphasis: 'is not',
    infoLine1b: ' required to be generated and attached until the case reaches AFE Review. Land users may modify all Title Clearance details and generate the Title Clearance PDF after submitting this step (even if attaching now).',
    infoLine2: 'Please select whether to attach the Title Clearance PDF now or prior to AFE Review completion.',
    warningLine1: 'Once generated, the Title Clearance will require Land Supervisor approval.',
    warningLine2: 'Once approval is received, you must flag the Title Clearance as approved via the \'Edit Land Details\' functionality.',
    warningLine3: 'You may find all non-approved Title Clearance jobs on the Land Dashboard until the \'Title Clearance Completion\' tab.',
    warningLine4: 'If pre-approval was received, you may mark the Title Clearance as approved in this modal.',
    generateAttachPdfLabel: 'Attach & Generate Title Clearance PDF',
    approvedBySupervisorLabel: 'Approved by Supervisor?',
    selectPlaceholder: '-- Select --',
    submit: 'Submit',
    cancel: 'Cancel',
  },
  paSurfaceCost: {
    header: {
      titleSuffix: 'Surface Cost Estimate',
      badge: 'Surface Cost Estimate',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    sections: {
      wellInformation: 'Well Information',
      aesEstimate: 'AES Cost Estimate',
      aefEstimate: 'AEF Cost Estimate',
    },
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      costCenter: 'Cost Center',
      area: 'Area',
      state: 'State',
      companyCode: 'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      oil: 'Oil',
      water: 'Water',
      gas: 'Gas',
      latitude: 'Latitude',
      longitude: 'Longitude',
      costEstimateType: 'Cost Estimate Type',
      totalBeforeGa: 'Total Before G&A ($)',
      gaPercent: 'G&A (%)',
      gaCost: 'G&A Cost ($)',
      totalAfterGa: 'Total After G&A ($)',
      summaryOfWork: 'Summary of Work',
      summaryOfWorkCharsRemaining: 'characters remaining',
    },
    estimateTypes: {
      aes: 'Surface Cost',
      aef: 'Facilities Decom Cost',
    },
    actions: {
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      submit: 'Submit',
    },
    validation: {
      wellNameRequired: 'Well Name is required.',
      api14Required: 'API 14 is required.',
      fotRequired: 'FOT is required.',
      areaRequired: 'Area is required.',
      costCenterRequired: 'Cost Center is required.',
      aesTotalBeforeGaRequired: 'Total Before G&A is required for the AES estimate.',
    },
  },
  paSiteReview: {
    header: {
      titleSuffix: 'Survey / AFE Review',
      badge: 'Survey/AFE',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    sections: {
      wellInformation: 'Well Information',
    },
    wellInfo: {
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      area: 'Area',
      costCenter: 'Cost Center',
      state: 'State',
      companyCode: 'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      oil: 'Oil',
      water: 'Water',
      gas: 'Gas',
      latitude: 'Latitude',
      longitude: 'Longitude',
      validation: {
        wellNameRequired: 'Well Name is required.',
        api14Required: 'API 14 is required.',
        fotRequired: 'FOT is required.',
        areaRequired: 'Area is required.',
        costCenterRequired: 'Cost Center is required.',
      },
    },
    tabs: {
      surfaceSurvey: 'Surface Survey',
      afeReview: 'AFE Review',
    },
    actions: {
      back: 'Back',
      save: 'Save',
      cancel: 'Cancel',
      submitSurvey: 'Submit',
      reviewSurvey: 'Review Site Survey',
      submitAfe: 'Submit',
    },
    survey: {
      instruction: 'Please complete the Site Survey and indicate if a powerline is nearby.',
      powerlinePrefix: 'Is there a powerline within',
      powerlineSuffix: 'feet of the well?',
      isPowerlineWithinThreshold: 'Is there a powerline within threshold distance of the well?',
      sections: {
        projectInformation: 'Project Information',
        locInformation: 'LOC Information - (Check all that are applicable)',
        wellInformation: 'Well Information - (Check all that are applicable)',
        cboInformation: 'CBO Information - (Check all that are applicable)',
        wellheadRating: 'Wellhead/Size/Rating Info - (Check all that are applicable)',
        locationNeeds: 'Location Needs - (Check all that are applicable)',
        additional: 'Additional',
      },
      fields: {
        workBoundariesStacked: 'Work Boundaries Stacked?',
        selectPlaceholder: '-Select-',
        field: 'Field',
        latitude: 'Latitude',
        longitude: 'Longitude',
        elevation: 'Elevation',
        section: 'Section',
        township: 'Township',
        range: 'Range',
        leaseIdentificationNumber: 'Lease Identification Number',
        siteEvaluatorName: 'Site Evaluator Name',
        siteEvaluationDate: 'Site Evaluation Date',
        anchorTestDate: 'Anchor Test Date',
        isElectrical: 'Electrical',
        isUnitOnLoc: 'Unit on LOC',
        isSkidOnLoc: 'Skid on LOC',
        isConcreteOnLoc: 'Concrete on LOC',
        isRodsVisible: 'Rods Visible',
        isSlimhole: 'Slimhole',
        isFlowlineRemoval: 'Flowline Removal/Disconnect',
        flowlineRemovalDetail: 'Flowline Removal/Disconnect Detail',
        isCboSign: 'CBO Sign',
        isStainingOfGround: 'Staining of ground',
        isHolesByWell: 'Holes by well',
        isWellTemp: 'Well Temp',
        wellTempDetail: 'Well Temp Detail',
        wellheadSizeRatingInfo: 'Wellhead/Size/Rating Info',
        pressure: 'Pressure',
        isCorrosion: 'Corrosion',
        isApiWellhead: 'API Wellhead',
        isSlipType: 'Slip Type',
        isThreadsShowing: 'Threads Showing',
        isNonApiWellhead: 'Non API Wellhead',
        isLeak: 'Leak',
        isDonutRams: 'Donut Rams',
        isBullPlugged: 'Bull Plugged',
        isBolts: 'Bolts',
        conditionComments: 'Condition Comments',
        isBackhoePrepCrew: 'Backhoe Prep Crew',
        isWellheadPrepCrew: 'Wellhead Prep Crew',
        isNeedsRig: 'Needs Rig',
        isNeedsCoil: 'Needs Coil',
        locationPrepComments: 'Location Prep Comments',
        projectDescriptionDrivingDirections: 'Project Description / Driving Directions',
        supportingPhotos: 'Supporting Photos',
        supportingPhotosNote: 'Photos and rich text will be copied verbatim into the generated Site Evaluation PDF.',
      },
      validation: {
        siteEvaluationDateRequired: 'Site Evaluation Date is required.',
        anchorDateFuture: 'Anchor Test Date cannot be a future date.',
      },
    },
    afe: {
      sections: {
        afeReview: 'AFE Review',
        costSummary: 'Cost Summary (Read-only)',
        approvedCosts: 'Approved Costs',
        afeReference: 'AFE Reference',
        wbs: 'WBS Entries',
        facilityReview: 'Facility Review',
        facilityReviewLocked: 'Facility Decommission spinoff has already been created. These fields are locked.'
      },
      fields: {
        aesTotalBeforeGa: 'AES Cost Estimate (Before G&A)',
        aesTotalAfterGa: 'AES Cost Estimate (After G&A)',
        aefTotalBeforeGa: 'AEF Cost Estimate (Before G&A)',
        aefTotalAfterGa: 'AEF Cost Estimate (After G&A)',
        abnCostEstimate: 'ABN Cost Estimate',
        approvedAes: 'Approved AES ($)',
        approvedAef: 'Approved AEF ($)',
        approvedAbn: 'Approved ABN ($)',
        companyCode: 'Company Code',
        afeLink: 'AFE Link',
        createFacilityDecom: 'Create Facility Decom work?',
        facilityName: 'Facility Name',
        facilityId: 'Facility ID',
        facilityChevno: 'Chevno',
      },
      tooltips: {
        createFacilityDecom: 'Select this option if this is the last well associated with a facility to indicate facility decommissioning work is needed.',
      },
      wbs: {
        addRow: 'Add Row',
        noItems: 'No WBS entries. Add at least one row before submitting.',
        wbsNumber: 'WBS #',
        allocation: 'WBS %',
        comments: 'WBS Comments',
        deleteRow: 'Delete row',
        attachApprovedWbs:    'Attach Approved WBS',
        approvedWbsAttached:    'Approved WBS is attached.',
        approvedWbsNotAttached: 'No Approved WBS attached.',
      },
      validation: {
        companyCodeRequired: 'Company Code is required.',
        afeLinkRequired: 'AFE Link is required.',
        afeLinkInvalidUrl: 'AFE Link must start with https://afe.chevron.com or https://afenav-prod.azure.chevron.com.',
        wbsRequired: 'At least one WBS entry is required.',
        facilityNameRequired: 'Facility Name is required.',
        facilityChevnoRequired: 'Chevno is required.',
      },
    },
  },
  paWorkOrder: {
    header: {
      titleSuffix: 'Work Order Submission',
      badge: 'Work Order Submission',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    sections: {
      wellInformation: 'Well Information',
      workOrderSubmission: 'Work Order Submission',
    },
    wellInfo: {
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      area: 'Area',
      costCenter: 'Cost Center',
      state: 'State',
      companyCode: 'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      latitude: 'Latitude',
      longitude: 'Longitude',
      api10: 'API 10',
      wbsNumber: 'WBS Number',
    },
    fields: {
      // §9.2.8 — confirmed p-checkbox (NOT boolean dropdown)
      areWorkOrdersSubmitted: 'Have work orders been submitted?',
      additionalComments: 'Additional Comments',
    },
    actions: {
      back: 'Back',
      cancel: 'Cancel',
      save: 'Save',
      submit: 'Submit',
    },
    validation: {
      // §9.2.8.4 — exact wording required
      workOrdersNotSubmitted: 'Work orders must be submitted before you can proceed.',
      requiredFields: 'Please fill in all required fields before submitting.',
      wellNameRequired: 'Well Name is required.',
      api14Required: 'API 14 is required.',
      fotRequired: 'FOT is required.',
      areaRequired: 'Area is required.',
      costCenterRequired: 'Cost Center is required.',
    },
  },
  paCentralMaintenance: {
    header: {
      titleSuffix: 'Central Maintenance',
      badge: 'Central Maintenance',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    sections: {
      wellInformation: 'Well Information',
      workOrders: 'EAM Work Orders',
    },
    // §9.2.9.2 WO table columns
    fields: {
      wellName: 'Well Name',
      api14: 'API 14',
      fot: 'FOT',
      costCenter: 'Cost Center',
      area: 'Area',
      state: 'State',
      companyCode: 'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode: 'Plant Code',
      failureDate: 'Failure Date',
      oil: 'Oil',
      water: 'Water',
      gas: 'Gas',
      latitude: 'Latitude',
      longitude: 'Longitude',
      workOrderNumber: 'WO #',
      description: 'Description',
      woStatusCode: 'Status',
      createdDateTime: 'Created On',
      scheduledDate: 'Scheduled',
      completedDate: 'Completed',
      assignee: 'Assignee',
      // §9.2.9.3 activity columns
      comment: 'Comment',
      commentDate: 'Date',
      commentBy: 'User',
      // §9.2.9.4 modal extra columns
      updatedDate: 'Last Updated',
      updatedBy: 'Updated By',
      woComments: 'Last Comment',
      // misc
      lastPolled: 'Last refreshed',
      noWorkOrders: 'No EAM work orders found for this case.',
    },
    actions: {
      back: 'Back',
      cancel: 'Cancel',
      save: 'Save',
      saveWellInfo: 'Save Well Information',
      refresh: 'Refresh WOs',
      submit: 'Submit',
      expandActivities: 'Expand activities',
      collapseActivities: 'Collapse activities',
    },
    // §9.2.9.4 — active-WO confirmation modal (BRU-064)
    modal: {
      header: 'Active Work Orders',
      description: 'There are active (incomplete) EAM work orders on this case. Review the work orders below and confirm you want to acknowledge and proceed.',
      confirm: 'Acknowledge & Submit',
      cancel: 'Cancel',
    },
  },

  // ── Phase 4.2: Dig Plan workspace (§9.2.14) ─────────────────────────────────
  paDigPlan: {
    header: {
      titleSuffix: 'Dig Plan',
      badge: 'Surface Dig Plan',
      wbLink: 'Open WB Case',
      fdLink: 'Open FD Case',
      recLink: 'Open REC Case',
    },
    steps: {
      creation:  'Creation',
      review:    'Review',
      execution: 'Execution',
    },
    sections: {
      businessPartners:   'Business Partners',
      digPlanAttachment:  'Dig Plan Attachment',
      digPlanApproval:    'Dig Plan Review',
      digPlanExecution:   'Dig Plan Execution',
    },
    creation: {
      returnedCommentsTitle: 'Returned: Rejection Comments',
      noEmails:              'No business partner emails added.',
    },
    fields: {
      email:              'Business Partner Email',
      approvalComments:   'Approval Comments',
      isWellPrepComplete: 'Well prep is complete',
    },
    actions: {
      addEmail:      'Add Email',
      deleteRow:     'Delete row',
      attachDigPlan: 'Attach Dig Plan',
      cancel:        'Cancel',
      save:          'Save',
      reject:        'Reject',
      approve:       'Approve',
      submit:        'Submit',
    },
    validation: {
      atLeastOneEmail: 'At least one business partner email is required.',
      invalidEmail:    'Please enter a valid email address.',
      wellPrepRequired: 'Well prep must be confirmed before submitting.',
    },
    attachment: {
      attached:    'Dig Plan is attached.',
      notAttached: 'Dig Plan is not attached.',
    },
    review: {
      digPlanFile: 'Dig Plan file',
      noDigPlan:   'No Dig Plan file has been attached.',
      uploadedBy:  'Uploaded by',
      uploadedOn:  'on',
      download:    'Download',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
  },

  // ── Phase 4.2: Dig Plan Rejection Modal ──────────────────────────────────────
  paDigPlanRejectionModal: {
    title:        'Reject Dig Plan',
    commentsLabel: 'Rejection Comments',
    reject:       'Reject',
    cancel:       'Cancel',
    validation: {
      commentsRequired: 'Rejection comments are required to reject the Dig Plan.',
    },
  },

  // ── Phase 4.2: WB Common ─────────────────────────────────────────────────────
  wbCommon: {
    workflowLabel: 'WB Workflow',
    backToParent:  'Back to PA Case',
    comments: {
      title:          'Comments',
      noComment:      'No comments have been added to this case.',
      viewInParent:   'View in PA Case',
    },
    wellInformation: {
      sectionTitle:        'Well Information',
      wellName:            'Well Name',
      api14:               'API 14',
      fot:                 'FOT',
      area:                'Area',
      costCenter:          'Cost Center',
      state:               'State',
      localReferenceNumber: 'Local Reference Number',
      plantCode:           'Plant Code',
      failureDate:         'Failure Date',
      companyCode:         'Company Code',
      oil:                 'Oil',
      water:               'Water',
      gas:                 'Gas',
      latitude:            'Latitude',
      longitude:           'Longitude',
    },
  },

  // ── Phase 4.2: WB Back Confirm Dialog ────────────────────────────────────────
  wbBackConfirmDialog: {
    title:   'Confirm — Return to Cost Estimate',
    message: 'Going back will suspend the procedure requirement for this case and return it to the Subsurface Cost Estimate stage. Do you want to proceed?',
    confirm: 'Confirm',
    cancel:  'Cancel',
  },

  // ── Phase 4.2: WB Subsurface Cost Estimate workspace (§9.2.16) ──────────────
  wbCost: {
    header: {
      titleSuffix: 'Subsurface Cost Estimate',
      badge:       'WB Cost Estimate',
    },
    stages: {
      costEstimate:   'Cost Estimate',
      procedure:      'Short Procedure',
      permitApproval: 'Permit Approval',
    },
    sections: {
      abn: 'ABN Cost Estimate',
      abp: 'ABP Cost Estimate',
    },
    fields: {
      costEstimateType:            'Cost Estimate Type',
      costEstimateTypePlaceholder: 'Select type',
      abnDays:          'Days',
      abnCostPerDay:    'Cost per day ($)',
      abnTotalDaysCost: 'Total Days Cost ($)',
      abnContingency:   'Contingency ($)',
      abnCost:          'ABN Cost ($)',
      abnSummaryOfWork: 'Summary of Work',
      abpCostEstimate:  'ABP Cost Estimate',
      abpSummaryOfWork: 'Summary of Work',
    },
    actions: {
      cancel: 'Cancel',
      save:   'Save',
      submit: 'Submit',
    },
    validation: {
      abpCostEstimateRequired:  'ABP Cost Estimate is required.',
      costEstimateTypeRequired: 'Cost Estimate Type is required.',
      abnDaysRequired:          'Days is required.',
      abnCostPerDayRequired:    'Cost per day is required.',
      abnContingencyRequired:   'Contingency is required.',
    },
  },

  // ── Phase 4.2: WB Short Procedure workspace (§9.2.17) ───────────────────────
  wbProcedure: {
    header: {
      titleSuffix: 'Subsurface Procedure',
      badge:       'WB Short Procedure',
    },
    sections: {
      procedure:     'Short Procedure',
      formationTops: 'Formation Tops',
      tubularsRods:  'Tubulars / Rods',
      permit:        'Permit',
      uploadFiles:   'Upload Files',
    },
    fields: {
      procedureTemplate:            'Procedure Template',
      procedureTemplatePlaceholder: 'Select a template',
      procedureDetails:    'Procedure Details',
      paProcedureAttachment: 'P\u0026A Procedure',
      hasPermitBeenRequested: 'Has the subsurface permit been requested?',
      permitExpirationDate: 'Permit Expiration Date',
      formationName:       'Formation Name',
      topDepth:            'Top Depth (ft)',
      currentWellboreDiagram:  'Current Wellbore Diagram',
      proposedWellboreDiagram: 'Proposed Wellbore Diagram',
      permitAttachment:        'Permit',
    },
    upload: {
      selectFile:  'Browse…',
      notAttached: 'Not attached',
      attachCurrentWellboreDiagram:  'Attach Current Wellbore Diagram',
      attachProposedWellboreDiagram: 'Attach Proposed Wellbore Diagram',
      attachPermit:                  'Attach Permit',
      attachPaProcedure:             'Attach P\u0026A Procedure',
    },
    formationTops: {
      empty: 'No formation tops on this case.',
    },
    tubulars: {
      notAttached: 'Tubulars and Rods (PDF) is not attached.',
    },
    actions: {
      cancel:         'Cancel',
      back:           'Back',
      save:           'Save',
      submit:         'Submit',
    },
    validation: {
      procedureDetailsRequired:        'Procedure details are required.',
      overwriteWarning:                'Selecting a new template will override existing values.',
      paProcedureRequired:             'The P\u0026A Procedure attachment is required to proceed.',
      currentWellboreDiagramRequired:  'Current Wellbore Diagram (PDF) is required.',
      proposedWellboreDiagramRequired: 'Proposed Wellbore Diagram is required.',
      formationTopsRequired:           'Formation Tops are required. Please ensure the parent PA case has formation tops entered.',
      permitRequired:                  'A permit attachment is required when the permit has not been requested.',
      permitExpirationDateRequired:    'Permit Expiration Date is required when a permit is attached.',
      permitExpirationDatePast:        'Permit Expiration Date cannot be in the past.',
    },
  },

  // ── Phase 4.2: WB Permit Approval workspace (§9.2.18) ───────────────────────
  wbPermit: {
    header: {
      titleSuffix: 'Permit Approval',
      badge:       'WB Permit Approval',
    },
    sections: {
      procedure:              'Short Procedure',
      formationTops:          'Formation Tops',
      uploadFiles:            'Upload Files',
      permitDetails:          'Permit Details',
      teamLeadApproval:       'Team Lead Approval',
      superintendentApproval: 'Superintendent Approval',
    },
    fields: {
      permitExpirationDate:      'Permit Expiration Date',
      titleClearanceExpirationDate: 'Title Clearance Expiration Date',
      isTeamLeadApproved:        'Team Lead Approved?',
      teamLeadComments:          'Team Lead Comments',
      isSuperintendentApproved:  'Superintendent Approved?',
      superintendentComments:    'Superintendent Comments',
      formationName:             'Formation Name',
      topDepth:                  'Top Depth (ft)',
      tubularsRods:              'Tubulars and Rods',
      currentWellboreDiagram:    'Current Wellbore Diagram',
      proposedWellboreDiagram:   'Proposed Wellbore Diagram',
      permitAttachment:          'Subsurface Permit',
      paProcedureAttachment:     'P&A Procedure',
    },
    upload: {
      notAttached:  'Not attached',
      attachPermit: 'Attach Permit',
    },
    procedure: {
      empty: 'No procedure details available.',
    },
    formationTops: {
      empty: 'No formation tops on this case.',
    },
    approvalHistory: {
      teamLeadApproved:       'Team Lead approved on',
      superintendentApproved: 'Superintendent approved on',
    },
    actions: {
      cancel:          'Cancel',
      save:            'Save',
      submit:          'Submit',
      editProcedure:   'Edit Procedure',
    },
    validation: {
      permitMissing:           'Please attach the subsurface permit.',
      permitDateRequired:      'Permit Expiration Date is required.',
      permitExpired:           'Permit Expiration must not be in the past.',
      titleClearanceDateRequired: 'Title Clearance Expiration Date is required.',
      bothApprovalsRequired:   'Both the Team Lead & Superintendent must approve to proceed.',
    },
  },

  // ── Phase 5.2: PA Scheduling Workspace ───────────────────────────────────────
  paSchedulingWorkspace: {
    header: {
      titleSuffix: 'Scheduling',
      badge:       'Scheduling',
      wbLink:      'Open WB Case',
      fdLink:      'Open FD Case',
      recLink:     'Open REC Case',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
    sections: {
      wellview:             'Wellview Pre-Check',
      scheduling:           'Scheduling Details',
      conservationDocument: 'Conservation Document',
      queueOrder:           'Queue Order',
    },
    queue: {
      type:        'Type',
      caseNumber:  'Case Number',
      wellName:    'Well Name',
      queueOrder:  'Queue Order',
      paTaDeadline: 'PA/TA Deadline',
      ssCostType:  'SS Cost Type',
      dragRow:     'Drag to reorder',
    },
    fields: {
      hasJobBeenEnteredIntoWellview: 'Has the job been entered into Wellview?',
      wellviewJobType:               'Wellview Job Type',
      wellviewJobCreationDate:       'Wellview Job Creation Date',
      rigId:                         'Rig',
      queueOrder:                    'Queue Order',
      projectedJobDays:              'Projected Job Days',
      paTaDeadline:                  'PA/TA Deadline',
      ssCostType:                    'SS Cost Type',
    },
    placeholders: {
      rigId: 'Select a rig',
    },
    messages: {
      wbGateNotice:                    'The Wellbore case must be resolved and Wellview entry completed before scheduling can be edited.',
      conservationDocNotice:           'Generate the conservation document to attach to this case.',
      conservationDocAlreadyGenerated: 'Conservation document has already been generated.',
      conservationDocGenerated:        'Conservation document generated successfully.',
      saved:                           'Scheduling saved.',
      wellviewSaved:                   'Wellview data saved.',
    },
    actions: {
      openWellviewDialog:    'Edit Wellview Details',
      generateConservationDoc: 'Generate Conservation Document',
      downloadConservationTemplate: 'Download Conservation Measures Template',
      cancel:                'Cancel',
      submit:                'Submit',
    },
    validation: {
      rigIdRequired: 'Rig is required.',
    },
  },

  // ── Phase 5.2: PA Wellview Dialog ────────────────────────────────────────────
  paWellviewDialog: {
    title: 'Wellview Details',
    fields: {
      hasJobBeenEnteredIntoWellview:      'Has the job been entered into Wellview?',
      hasJobBeenEnteredIntoWellviewLabel: 'Yes, the job has been entered',
      wellviewJobType:                    'Wellview Job Type',
      wellviewJobCreationDate:            'Wellview Job Creation Date',
    },
    placeholders: {
      wellviewJobType: 'Enter job type',
    },
    validation: {
      wellviewJobTypeRequired:         'Wellview job type is required.',
      wellviewJobCreationDateRequired: 'Wellview job creation date is required.',
    },
  },

  // ── Phase 5.2: PA Execution Workspace ────────────────────────────────────────
  paExecutionWorkspace: {
    header: {
      titleSuffix: 'Execution',
      badge:       'Job Execution',
      recLink:     'Open REC Case',
      wbLink:      'Open WB Case',
      fdLink:      'Open FD Case',
    },
    sections: {
      wellInformation:    'Well Information',
      powerlineVariance:  'Powerline Variance',
      rodTubingRetrieval: 'Rod & Tubing Retrieval',
      subsurface:         'Subsurface Execution',
      conservationMeasures: 'Conservation Measures',
    },
    wellInfo: {
      wellName:            'Well Name',
      api14:               'API 14',
      fot:                 'FOT ID',
      area:                'Area',
      costCenter:          'Cost Center',
      state:               'State',
      companyCode:         'Company Code',
      localReferenceNumber:'Local Reference Number',
      plantCode:           'Plant Code',
      failureDate:         'Failure Date',
      oil:                 'Oil (Bbl/d)',
      water:               'Water (Bbl/d)',
      gas:                 'Gas (Mcf/d)',
      latitude:            'Latitude',
      longitude:           'Longitude',
    },
    fields: {
      isPowerlineVarianceNeeded:          'Is Powerline Variance Needed?',
      powerlineDistancePrefix:            'Is there a powerline within',
      powerlineDistanceSuffix:            'feet of the well?',
      powerlineVarianceApprovalRequestor: 'Approval Requestor',
      approvalComments:                   'Approval Comments',
      keepingTubingMaterial:              'Keeping tubing material (no retrieval required)',
      retrievalPartner:                   'Retrieval Partner',
      retrievalPartnerEmails:             'Retrieval Partner Emails',
      retrievalPartnerEmail:              'Retrieval Partner Email',
      pluggingDate:                       'Plugging Date',
    },
    placeholders: {
      powerlineRequestor: 'Enter requestor email',
      retrievalPartner:   'Select retrieval partner',
      retrievalEmail:     'Enter email',
    },
    tooltips: {
      powerlineVarianceNeeded: 'When \'yes\', the Powerline Variance Plan attachment and Superintendent Approval is required.',
      keepingTubingMaterial:   'Rod and Tubing Retrieval request is required when not keeping material.',
      approvalComments:        'Approval comments are required when rejecting this job.',
    },
    messages: {
      powerlineApproved:         'Powerline variance plan has been approved.',
      powerlineRejected:         'Powerline variance plan has been rejected.',
      powerlineVariancePlanNote: 'Upload the powerline variance plan and submit it for superintendent approval.',
      powerlinePlanAttached:     'Powerline Variance Plan attached.',
      retrievalAttachmentNote:   'Upload the Rod & Tubing Retrieval document via the attachments panel.',
      powerlineUpdated:          'Powerline variance status updated.',
      saved:                     'Execution details saved.',
      retrievalDocumentAttached: 'Rod & Tubing Retrieval document attached.',
    },
    actions: {
      openPowerlineModal:              'Manage Powerline Variance Plan',
      attachPowerlinePlan:             'Attach Powerline Variance Plan',
      addRetrievalEmail:               'Add Email',
      deleteRow:                       'Remove row',
      attachRetrievalDocument:         'Upload Rod & Tubing Retrieval Document',
      submit:                          'Submit',
      downloadConservationTemplate:    'Download Conservation Measures Template',
    },
    validation: {
      powerlineRequestorRequired:    'Approval requestor email is required.',
      powerlinePlanRequired:         'A Powerline Variance Plan attachment is required.',
      retrievalEmailRequired:        'At least one retrieval partner email is required.',
      retrievalEmailInvalid:         'Enter a valid email address.',
      retrievalDocumentRequired:     'Rod & Tubing Retrieval document is required.',
      formInvalid:                   'Please fill in all required fields before submitting.',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
  },

  // ── Phase 5.2: PA Powerline Variance Modal ────────────────────────────────────
  paPowerlineVarianceModal: {
    title: 'Powerline Variance Plan',
    fields: {
      variancePlanAttachment: 'Powerline Variance Plan Document',
      approvalRequestor:      'Approval Requestor',
      approvalComments:       'Approval Comments',
      uploadedBy:             'Uploaded by',
    },
    tooltips: {
      approvalComments: 'Approval comments are required when rejecting this job.',
    },
    placeholders: {
      approvalComments: 'Enter approval or rejection comments...',
    },
    messages: {
      instructions:  'Upload the powerline variance plan document and submit it to the superintendent for approval.',
      uploadNote:    'Use the Attachments panel in the case header to upload the Powerline Variance Plan document.',
      approved:      'The powerline variance plan has been approved.',
      rejected:      'The powerline variance plan has been rejected.',
      noAttachment:  'No Powerline Variance Plan attachment found. Upload one via the Attachments panel.',
    },
    actions: {
      submitForApproval: 'Submit for Approval',
      approve:           'Approve',
      reject:            'Reject',
      download:          'Download',
    },
    validation: {
      commentsRequired: 'Approval comments are required when rejecting.',
    },
  },

  // ── Phase 5.2: PA Wellhead Cut-Off Workspace ──────────────────────────────────
  paWellheadCutoffWorkspace: {
    header: {
      titleSuffix: 'Wellhead Cut-Off',
      badge:       'Wellhead Cut-Off',
      recLink:     'Open REC Case',
      wbLink:      'Open WB Case',
      fdLink:      'Open FD Case',
    },
    sections: {
      wellInformation:   'Well Information',
      wellheadCutoff:    'Wellhead Cut Off',
      siteRestorePhotos: 'Site Restore Photos',
      notes:             'Notes',
      sendBack:          'Send Back to Scheduling',
    },
    wellInfo: {
      wellName:             'Well Name',
      api14:                'API 14',
      fot:                  'FOT',
      area:                 'Area',
      costCenter:           'Cost Center',
      state:                'State',
      companyCode:          'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode:            'Plant Code',
      failureDate:          'Failure Date',
      oil:                  'Oil',
      water:                'Water',
      gas:                  'Gas',
      latitude:             'Latitude',
      longitude:            'Longitude',
    },
    fields: {
      noteToCoordinator:    'Note to Coordinator',
      noteToReclamationTeam: 'Note to Reclamation Team',
      sendBackReason:       'Pre-Schedule Send Back Comment',
      siteRestorePhotos:    'Site Restore Photos',
    },
    placeholders: {
      noteToCoordinator:    'Enter any notes for the coordinator...',
      noteToReclamationTeam: 'Enter any notes for the reclamation team...',
      sendBackReason:       'Enter the pre-schedule send back comment...',
    },
    tooltips: {
      noteToCoordinator:    'Notes will be added to the email sent to the coordinator.',
      noteToReclamationTeam: 'Notes will be added to the email send to the Reclamation team if Reclamation will be spun-off.',
    },
    messages: {
      siteRestorePhotosNote: 'Upload Site Restore Photos via the Attachments panel in the case header. At least one photo is required before submitting.',
      recSpinoffCreated:     'A Reclamation case has been created from this PA case.',
      saved:                 'Wellhead cut-off details saved.',
      photoCount:            'photo(s) uploaded',
    },
    actions: {
      sendBack:                  'Send Back to Scheduling',
      submit:                    'Submit',
      uploadSiteRestorePhotos:   'Upload Site Restore Photos',
    },
    validation: {
      sendBackReasonRequired:      'Pre-Schedule Send Back Comment is required to send back.',
      siteRestorePhotoRequired:    'At least one Site Restore Photo is required before submitting.',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
  },

  // ── Phase 5.2: PA Close Out Workspace ────────────────────────────────────────
  paCloseOutWorkspace: {
    header: {
      titleSuffix: 'Close Out',
      badge:       'Close Out',
      wbLink:      'Open WB Case',
      fdLink:      'Open FD Case',
      recLink:     'Open REC Case',
    },
    sections: {
      wellInformation:    'Well Information',
      agencyNotification: 'Agency Notification',
      winNotification:    'WIN Notification',
    },
    wellInfo: {
      wellName:             'Well Name',
      api14:                'API 14',
      fot:                  'FOT',
      area:                 'Area',
      costCenter:           'Cost Center',
      state:                'State',
      companyCode:          'Company Code',
      localReferenceNumber: 'Local Reference Number',
      plantCode:            'Plant Code',
      failureDate:          'Failure Date',
      oil:                  'Oil',
      water:                'Water',
      gas:                  'Gas',
      latitude:             'Latitude',
      longitude:            'Longitude',
    },
    fields: {
      isAgencyNotified:     'Have you notified the agency yet?',
      agencyNotifiedDate:   'Agency Notified Date',
      isClosureApproved:    'Have they approved the closure?',
      agencyApprovalDate:   'Agency Approval Date',
      approvedSubsequent:   'Approved Subsequent',
      winRecipients:        'WIN Notification Recipients',
      winRecipientEmail:    'WIN Recipient Email',
      submitterName:        'Submitter Name',
      submitterEmail:       'Submitter Email',
    },
    placeholders: {
      winEmail: 'Enter email address',
    },
    tooltips: {
      winNotification: 'WIN (Well Information Network) notifications are sent to all listed recipients upon job completion.',
    },
    messages: {
      saved: 'Close out details saved.',
      resolved: 'This PA case has been completed successfully.',
      approvedSubsequentAttached:    'Approved Subsequent document is attached.',
      approvedSubsequentNotAttached: 'Approved Subsequent document is not yet attached.',
    },
    actions: {
      addRow:    'Add Recipient',
      deleteRow: 'Remove recipient',
      submit:    'Submit',
      attachApprovedSubsequent: 'Attach Approved Subsequent',
    },
    validation: {
      agencyNotifiedDateRequired: 'Agency notified date is required.',
      agencyApprovalDateRequired: 'Agency approval date is required.',
      agencyNotifiedRequired:     'Agency must be notified before submitting.',
      closureApprovedRequired:    'Closure must be approved by the agency before submitting.',
      approvedSubsequentRequired: 'An Approved Subsequent attachment is required to submit.',
      winRecipientRequired:       'At least one WIN notification recipient is required.',
      winRecipientEmailInvalid:   'Please enter a valid email address.',
    },
    conservationBadge: 'This Well is on a Protected Species polygon',
  },

  // ── Phase 5.2: PA Resolved Workspace ─────────────────────────────────────────
  paResolvedWorkspace: {
    header: {
      titleSuffix: 'Resolved',
    },
    fields: {
      resolutionStatus:      'Resolution Status',
      cancellationReason:    'Cancellation Reason',
      cancellationComments:  'Cancellation Comments',
    },
    messages: {
      completed:  'This PA case has been completed successfully.',
      cancelled:  'This PA case has been cancelled.',
    },
  },

  // ── Phase 5.2: PA Cancel Job Dialog ──────────────────────────────────────────
  paCancelJobDialog: {
    title: 'Cancel PA Case',
    fields: {
      reasonForCancellation: 'Reason for Cancellation',
      comments:              'Comments',
    },
    options: {
      duplicateHumanError:    'Duplicate/Human Error',
      productionImprovement:  'Production Improvement',
      wellDivested:           'Well Divested',
    },
    placeholders: {
      reason:   'Select a reason',
      comments: 'Enter comments...',
    },
    messages: {
      warning: 'Warning: Cancelling this case is irreversible. Please confirm the reason and add any relevant comments.',
    },
    actions: {
      confirm: 'Confirm Cancellation',
    },
    validation: {
      reasonRequired:   'Cancellation reason is required.',
      commentsRequired: 'Comments are required.',
    },
  },

  paWorkflowTabs: {
    paWorkbook:           'PA Workbook',
    landReview:           'Land Review',
    fsmCostEstimate:      'FSM Cost Estimate',
    surfaceSurvey:        'Surface Survey',
    afeReview:            'AFE Review',
    workOrderSubmission:  'Work Order Submission',
    siteExcavation:       'Site Excavation',
    digPlan:              'Dig Plan',
    execution:            'Execution',
    wellheadCutoff:       'Wellhead Cutoff',
    jobCloseOut:          'Job Close Out',
    comments:             'Comments',
  },

  wbWorkflowTabs: {
    paWorkbook:     'PA Workbook',
    landReview:     'Land Review',
    costEstimate:   'Cost Estimate',
    procedure:      'Procedure',
    permitApproval: 'Permit Approval',
    comments:       'Comments',
  },
  historicalJobsPage: {
    filters: {
      dateFrom: 'Date From',
      dateTo: 'Date To',
      apply: 'Apply Filters',
      export: 'Export to Excel',
      searchPlaceholder: 'Search filtered rigless results',
    },
    columns: {
      caseNumber: 'Case Number',
      wellRef: 'Well Ref',
      api10: 'API10',
      operationalDate: 'Operational Date',
      status: 'Status',
    },
    empty: {
      pullRequests: 'No historical pull request jobs found for the selected date range.',
      rigless: 'No historical rigless jobs found for the selected date range.',
      plugAbandonment: 'No historical plug and abandonment jobs found for the selected date range.',
      reclamations: 'No historical reclamation jobs found for the selected date range.',
      facilityDecommission: 'No historical facility decommission jobs found for the selected date range.',
      search: 'No rigless results match the current search.',
    },
    errors: {
      loadFailed: 'Failed to load historical jobs.',
      exportFailed: 'Failed to export historical jobs.',
      invalidDateRange: 'Date From must be on or before Date To.',
      missingDates: 'Date From and Date To are required.',
    },
  },
};


export default en;
